export const cipcareermapMap = [
    {
        "career_code": "19101100",
        "cipt_code": "010000",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "010000",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "010000",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "010000",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010000",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010101",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010101",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010101",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010102",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010102",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "010103",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010103",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "010103",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010104",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010104",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010104",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010104",
        "affinityScore": "1"
    },
    {
        "career_code": "13102100",
        "cipt_code": "010105",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010105",
        "affinityScore": "1"
    },
    {
        "career_code": "41401200",
        "cipt_code": "010105",
        "affinityScore": "1"
    },
    {
        "career_code": "15123200",
        "cipt_code": "010106",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "010106",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010199",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010199",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010199",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010201",
        "affinityScore": "1"
    },
    {
        "career_code": "49304100",
        "cipt_code": "010201",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010204",
        "affinityScore": "1"
    },
    {
        "career_code": "45209100",
        "cipt_code": "010204",
        "affinityScore": "1"
    },
    {
        "career_code": "49304100",
        "cipt_code": "010204",
        "affinityScore": "1"
    },
    {
        "career_code": "49301100",
        "cipt_code": "010205",
        "affinityScore": "1"
    },
    {
        "career_code": "49304100",
        "cipt_code": "010205",
        "affinityScore": "1"
    },
    {
        "career_code": "49304200",
        "cipt_code": "010205",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "010207",
        "affinityScore": "1"
    },
    {
        "career_code": "49304100",
        "cipt_code": "010207",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010299",
        "affinityScore": "1"
    },
    {
        "career_code": "49304100",
        "cipt_code": "010299",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010301",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010301",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010301",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010302",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010302",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010302",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010302",
        "affinityScore": "1"
    },
    {
        "career_code": "45202100",
        "cipt_code": "010302",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010303",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010303",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010303",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010304",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010304",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010304",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010304",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010306",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010306",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010306",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010307",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010307",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010307",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010307",
        "affinityScore": "1"
    },
    {
        "career_code": "45202100",
        "cipt_code": "010307",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010308",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "010308",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "010308",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010308",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "010308",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010308",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010310",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010310",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010310",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010310",
        "affinityScore": "1"
    },
    {
        "career_code": "45202100",
        "cipt_code": "010310",
        "affinityScore": "1"
    },
    {
        "career_code": "45209300",
        "cipt_code": "010310",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010399",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010399",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010399",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "010401",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010401",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010401",
        "affinityScore": "1"
    },
    {
        "career_code": "45201100",
        "cipt_code": "010401",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "010504",
        "affinityScore": "1"
    },
    {
        "career_code": "39202100",
        "cipt_code": "010504",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010505",
        "affinityScore": "1"
    },
    {
        "career_code": "39201100",
        "cipt_code": "010505",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010507",
        "affinityScore": "1"
    },
    {
        "career_code": "39201100",
        "cipt_code": "010507",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "010509",
        "affinityScore": "1"
    },
    {
        "career_code": "39202100",
        "cipt_code": "010509",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010601",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010601",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010601",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "010601",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "010601",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010603",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010603",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "010603",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "010603",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010604",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010604",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "010604",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "010604",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010604",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010605",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "010605",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "010605",
        "affinityScore": "1"
    },
    {
        "career_code": "37301200",
        "cipt_code": "010605",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "37301200",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "45401100",
        "cipt_code": "010606",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010607",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "010607",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "010607",
        "affinityScore": "1"
    },
    {
        "career_code": "37301200",
        "cipt_code": "010607",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "010608",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010609",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010609",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010610",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010610",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "010701",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010701",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010801",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "010802",
        "affinityScore": "1"
    },
    {
        "career_code": "27401100",
        "cipt_code": "010802",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010901",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010901",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "010901",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010901",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010901",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010901",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010902",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010902",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010902",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010902",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010903",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010903",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010903",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010904",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010904",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010904",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010904",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010905",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010905",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "010905",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010905",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010905",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010905",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010906",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010906",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010906",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010906",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010907",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010907",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "010907",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010907",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010907",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010907",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "010999",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "010999",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "010999",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "010999",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "010999",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "011001",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "011001",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011001",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "011002",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "011002",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "011003",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "011003",
        "affinityScore": "1"
    },
    {
        "career_code": "51309200",
        "cipt_code": "011003",
        "affinityScore": "1"
    },
    {
        "career_code": "51901200",
        "cipt_code": "011003",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "011004",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "011004",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011004",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011004",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "011004",
        "affinityScore": "1"
    },
    {
        "career_code": "51901200",
        "cipt_code": "011004",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "011005",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "011005",
        "affinityScore": "1"
    },
    {
        "career_code": "51309200",
        "cipt_code": "011005",
        "affinityScore": "1"
    },
    {
        "career_code": "51901200",
        "cipt_code": "011005",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "011099",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "011099",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011099",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "011101",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011101",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "011101",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011101",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "011101",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "011101",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "011102",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011102",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "011102",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011102",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "011102",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "011102",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "011103",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011103",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011103",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "011103",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011104",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011104",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "011105",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011105",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011105",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "011105",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "011106",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011199",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011199",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011201",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "011201",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011201",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011202",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011202",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011203",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "011203",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011203",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "011299",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "011299",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "011399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018001",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018001",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018101",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018101",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018102",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018102",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018103",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018103",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018103",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018104",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018104",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018105",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018105",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018105",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018106",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018106",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018106",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018107",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018107",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018107",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018108",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018108",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018108",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018109",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018109",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018109",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018110",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018110",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018110",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018111",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018111",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018111",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "018199",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018199",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "018199",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "018201",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "018201",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "018201",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "018202",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "018202",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "018202",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "018202",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "018203",
        "affinityScore": "1"
    },
    {
        "career_code": "43417100",
        "cipt_code": "018203",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "018204",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "018204",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "018301",
        "affinityScore": "1"
    },
    {
        "career_code": "29205600",
        "cipt_code": "018301",
        "affinityScore": "1"
    },
    {
        "career_code": "31909600",
        "cipt_code": "018301",
        "affinityScore": "1"
    },
    {
        "career_code": "29205600",
        "cipt_code": "018399",
        "affinityScore": "1"
    },
    {
        "career_code": "31909600",
        "cipt_code": "018399",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030101",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030101",
        "affinityScore": "1"
    },
    {
        "career_code": "19407100",
        "cipt_code": "030101",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030101",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "030103",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "030103",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "030103",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "030104",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "030104",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "030104",
        "affinityScore": "1"
    },
    {
        "career_code": "19407100",
        "cipt_code": "030104",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "030104",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030201",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030201",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "030204",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "030204",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "030204",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "030204",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030205",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030205",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030206",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030206",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "030207",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33102100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33201100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33202200",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33303100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "33909200",
        "cipt_code": "030208",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "030209",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "030209",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030299",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "030301",
        "affinityScore": "1"
    },
    {
        "career_code": "45303100",
        "cipt_code": "030301",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030501",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030501",
        "affinityScore": "1"
    },
    {
        "career_code": "19407100",
        "cipt_code": "030501",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030501",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "030501",
        "affinityScore": "1"
    },
    {
        "career_code": "45401100",
        "cipt_code": "030501",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030502",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030502",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030502",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030506",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030506",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030506",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030508",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030508",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030509",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030509",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030510",
        "affinityScore": "1"
    },
    {
        "career_code": "19407100",
        "cipt_code": "030510",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030510",
        "affinityScore": "1"
    },
    {
        "career_code": "45101100",
        "cipt_code": "030510",
        "affinityScore": "1"
    },
    {
        "career_code": "19407100",
        "cipt_code": "030511",
        "affinityScore": "1"
    },
    {
        "career_code": "45401100",
        "cipt_code": "030511",
        "affinityScore": "1"
    },
    {
        "career_code": "19103200",
        "cipt_code": "030599",
        "affinityScore": "1"
    },
    {
        "career_code": "19407100",
        "cipt_code": "030599",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030599",
        "affinityScore": "1"
    },
    {
        "career_code": "45401100",
        "cipt_code": "030599",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "030601",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "030601",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "030601",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "039999",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040201",
        "affinityScore": "1"
    },
    {
        "career_code": "17101100",
        "cipt_code": "040201",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040201",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040202",
        "affinityScore": "1"
    },
    {
        "career_code": "17101100",
        "cipt_code": "040202",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040202",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040299",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040301",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "040301",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040301",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "040301",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040401",
        "affinityScore": "1"
    },
    {
        "career_code": "17101100",
        "cipt_code": "040401",
        "affinityScore": "1"
    },
    {
        "career_code": "17101200",
        "cipt_code": "040401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040401",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040402",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040402",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "040402",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "040403",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040403",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040499",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040501",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040501",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "040501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040601",
        "affinityScore": "1"
    },
    {
        "career_code": "17101200",
        "cipt_code": "040601",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040601",
        "affinityScore": "1"
    },
    {
        "career_code": "17101100",
        "cipt_code": "040801",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "040801",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "040802",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040802",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040803",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040899",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "040901",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "040902",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "040902",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040902",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "040999",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "040999",
        "affinityScore": "1"
    },
    {
        "career_code": "11914100",
        "cipt_code": "041001",
        "affinityScore": "1"
    },
    {
        "career_code": "13202300",
        "cipt_code": "041001",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "041001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "041001",
        "affinityScore": "1"
    },
    {
        "career_code": "41902100",
        "cipt_code": "041001",
        "affinityScore": "1"
    },
    {
        "career_code": "41902200",
        "cipt_code": "041001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050102",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050103",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050104",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050105",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050106",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050107",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050108",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050109",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050110",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050111",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050112",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050113",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050114",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050115",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050116",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050117",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050118",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050119",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050120",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050121",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050122",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050123",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050124",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050125",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050126",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050127",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050128",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050129",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050130",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050131",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050132",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050133",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050134",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050135",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050136",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050199",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050200",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050202",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050203",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050206",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050207",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050208",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050209",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050210",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050211",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "050211",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050212",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "050299",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "059999",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "27301100",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "090100",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090101",
        "affinityScore": "1"
    },
    {
        "career_code": "27301100",
        "cipt_code": "090101",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090101",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "090101",
        "affinityScore": "1"
    },
    {
        "career_code": "27309900",
        "cipt_code": "090101",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090102",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090102",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "090102",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "090102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090401",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090401",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "090401",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "090401",
        "affinityScore": "1"
    },
    {
        "career_code": "43908100",
        "cipt_code": "090401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090402",
        "affinityScore": "1"
    },
    {
        "career_code": "27301100",
        "cipt_code": "090402",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090402",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "090402",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "090402",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090404",
        "affinityScore": "1"
    },
    {
        "career_code": "27402100",
        "cipt_code": "090404",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "090404",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090405",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090405",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090406",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090406",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090407",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090407",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090499",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090499",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090701",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "090701",
        "affinityScore": "1"
    },
    {
        "career_code": "27301100",
        "cipt_code": "090701",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090701",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "090701",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "090702",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "090702",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090702",
        "affinityScore": "1"
    },
    {
        "career_code": "27309900",
        "cipt_code": "090702",
        "affinityScore": "1"
    },
    {
        "career_code": "11201100",
        "cipt_code": "090900",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090900",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "090900",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "090900",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090900",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090900",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "090901",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "090901",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "090901",
        "affinityScore": "1"
    },
    {
        "career_code": "11201100",
        "cipt_code": "090902",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090902",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "090902",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "090902",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090902",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090902",
        "affinityScore": "1"
    },
    {
        "career_code": "11201100",
        "cipt_code": "090903",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090903",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090904",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "090904",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090904",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090904",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090904",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "090905",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "090905",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090905",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090905",
        "affinityScore": "1"
    },
    {
        "career_code": "13101100",
        "cipt_code": "090906",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090906",
        "affinityScore": "1"
    },
    {
        "career_code": "27209900",
        "cipt_code": "090906",
        "affinityScore": "1"
    },
    {
        "career_code": "27301100",
        "cipt_code": "090906",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090906",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090906",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090907",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090907",
        "affinityScore": "1"
    },
    {
        "career_code": "27302300",
        "cipt_code": "090907",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "090907",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "090908",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "090908",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "090908",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "090909",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "090909",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "091001",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "099999",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "099999",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "099999",
        "affinityScore": "1"
    },
    {
        "career_code": "27309900",
        "cipt_code": "100105",
        "affinityScore": "1"
    },
    {
        "career_code": "27401200",
        "cipt_code": "100105",
        "affinityScore": "1"
    },
    {
        "career_code": "27401400",
        "cipt_code": "100105",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "100105",
        "affinityScore": "1"
    },
    {
        "career_code": "27401100",
        "cipt_code": "100201",
        "affinityScore": "1"
    },
    {
        "career_code": "27401500",
        "cipt_code": "100201",
        "affinityScore": "1"
    },
    {
        "career_code": "27401200",
        "cipt_code": "100202",
        "affinityScore": "1"
    },
    {
        "career_code": "27401500",
        "cipt_code": "100202",
        "affinityScore": "1"
    },
    {
        "career_code": "27403100",
        "cipt_code": "100202",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "100202",
        "affinityScore": "1"
    },
    {
        "career_code": "27209100",
        "cipt_code": "100203",
        "affinityScore": "1"
    },
    {
        "career_code": "27401100",
        "cipt_code": "100203",
        "affinityScore": "1"
    },
    {
        "career_code": "27401400",
        "cipt_code": "100203",
        "affinityScore": "1"
    },
    {
        "career_code": "27309200",
        "cipt_code": "100204",
        "affinityScore": "1"
    },
    {
        "career_code": "27401200",
        "cipt_code": "100299",
        "affinityScore": "1"
    },
    {
        "career_code": "27403100",
        "cipt_code": "100299",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "100299",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100301",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100302",
        "affinityScore": "1"
    },
    {
        "career_code": "51511200",
        "cipt_code": "100302",
        "affinityScore": "1"
    },
    {
        "career_code": "43903100",
        "cipt_code": "100303",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100303",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "100304",
        "affinityScore": "1"
    },
    {
        "career_code": "43902100",
        "cipt_code": "100305",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100305",
        "affinityScore": "1"
    },
    {
        "career_code": "51511200",
        "cipt_code": "100305",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100306",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100307",
        "affinityScore": "1"
    },
    {
        "career_code": "51511200",
        "cipt_code": "100307",
        "affinityScore": "1"
    },
    {
        "career_code": "43903100",
        "cipt_code": "100308",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100308",
        "affinityScore": "1"
    },
    {
        "career_code": "51511100",
        "cipt_code": "100399",
        "affinityScore": "1"
    },
    {
        "career_code": "51511200",
        "cipt_code": "100399",
        "affinityScore": "1"
    },
    {
        "career_code": "51919400",
        "cipt_code": "100399",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15121100",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15124200",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15124400",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110101",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110102",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110102",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "110102",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110102",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15121100",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "110103",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110104",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110104",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110104",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110104",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110105",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110199",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110199",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125400",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110202",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110202",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110202",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110203",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110203",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110203",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110204",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110204",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110204",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110205",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110205",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110205",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110299",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "110301",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110401",
        "affinityScore": "1"
    },
    {
        "career_code": "15121100",
        "cipt_code": "110501",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "110501",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "110501",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110501",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110501",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110501",
        "affinityScore": "1"
    },
    {
        "career_code": "43902100",
        "cipt_code": "110601",
        "affinityScore": "1"
    },
    {
        "career_code": "43902200",
        "cipt_code": "110602",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125400",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125400",
        "cipt_code": "110801",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "110801",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "110801",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "110801",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "110801",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "110802",
        "affinityScore": "1"
    },
    {
        "career_code": "15124200",
        "cipt_code": "110802",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110802",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "110802",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "110802",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110803",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "110803",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "110803",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110804",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110804",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110804",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "110804",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110804",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "110804",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "110901",
        "affinityScore": "1"
    },
    {
        "career_code": "15121100",
        "cipt_code": "110901",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "110901",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "110901",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "110901",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110901",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "110902",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "111001",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "111001",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "111001",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "111001",
        "affinityScore": "1"
    },
    {
        "career_code": "15124400",
        "cipt_code": "111001",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "111002",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "111002",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "111002",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15124200",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15124400",
        "cipt_code": "111003",
        "affinityScore": "1"
    },
    {
        "career_code": "15125400",
        "cipt_code": "111004",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "111004",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "111005",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "111005",
        "affinityScore": "1"
    },
    {
        "career_code": "13108200",
        "cipt_code": "111005",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "111005",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "111005",
        "affinityScore": "1"
    },
    {
        "career_code": "15123100",
        "cipt_code": "111006",
        "affinityScore": "1"
    },
    {
        "career_code": "15123200",
        "cipt_code": "111006",
        "affinityScore": "1"
    },
    {
        "career_code": "11917100",
        "cipt_code": "120301",
        "affinityScore": "1"
    },
    {
        "career_code": "39401100",
        "cipt_code": "120301",
        "affinityScore": "1"
    },
    {
        "career_code": "39403100",
        "cipt_code": "120301",
        "affinityScore": "1"
    },
    {
        "career_code": "11917100",
        "cipt_code": "120302",
        "affinityScore": "1"
    },
    {
        "career_code": "39403100",
        "cipt_code": "120302",
        "affinityScore": "1"
    },
    {
        "career_code": "39401100",
        "cipt_code": "120303",
        "affinityScore": "1"
    },
    {
        "career_code": "39401200",
        "cipt_code": "120303",
        "affinityScore": "1"
    },
    {
        "career_code": "11917100",
        "cipt_code": "120399",
        "affinityScore": "1"
    },
    {
        "career_code": "39401200",
        "cipt_code": "120399",
        "affinityScore": "1"
    },
    {
        "career_code": "39403100",
        "cipt_code": "120399",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120401",
        "affinityScore": "1"
    },
    {
        "career_code": "39509100",
        "cipt_code": "120401",
        "affinityScore": "1"
    },
    {
        "career_code": "39509200",
        "cipt_code": "120401",
        "affinityScore": "1"
    },
    {
        "career_code": "39509300",
        "cipt_code": "120401",
        "affinityScore": "1"
    },
    {
        "career_code": "39509400",
        "cipt_code": "120401",
        "affinityScore": "1"
    },
    {
        "career_code": "39501100",
        "cipt_code": "120402",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120404",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120406",
        "affinityScore": "1"
    },
    {
        "career_code": "39509100",
        "cipt_code": "120406",
        "affinityScore": "1"
    },
    {
        "career_code": "39501100",
        "cipt_code": "120407",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120407",
        "affinityScore": "1"
    },
    {
        "career_code": "39509400",
        "cipt_code": "120408",
        "affinityScore": "1"
    },
    {
        "career_code": "39509400",
        "cipt_code": "120409",
        "affinityScore": "1"
    },
    {
        "career_code": "39509200",
        "cipt_code": "120410",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120411",
        "affinityScore": "1"
    },
    {
        "career_code": "39509100",
        "cipt_code": "120411",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "120412",
        "affinityScore": "1"
    },
    {
        "career_code": "39102200",
        "cipt_code": "120412",
        "affinityScore": "1"
    },
    {
        "career_code": "39501100",
        "cipt_code": "120412",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120412",
        "affinityScore": "1"
    },
    {
        "career_code": "39501100",
        "cipt_code": "120413",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120413",
        "affinityScore": "1"
    },
    {
        "career_code": "39509400",
        "cipt_code": "120414",
        "affinityScore": "1"
    },
    {
        "career_code": "39501200",
        "cipt_code": "120499",
        "affinityScore": "1"
    },
    {
        "career_code": "35101100",
        "cipt_code": "120500",
        "affinityScore": "1"
    },
    {
        "career_code": "35101200",
        "cipt_code": "120500",
        "affinityScore": "1"
    },
    {
        "career_code": "35201200",
        "cipt_code": "120500",
        "affinityScore": "1"
    },
    {
        "career_code": "35201400",
        "cipt_code": "120500",
        "affinityScore": "1"
    },
    {
        "career_code": "35201900",
        "cipt_code": "120500",
        "affinityScore": "1"
    },
    {
        "career_code": "35101100",
        "cipt_code": "120501",
        "affinityScore": "1"
    },
    {
        "career_code": "51301100",
        "cipt_code": "120501",
        "affinityScore": "1"
    },
    {
        "career_code": "35301100",
        "cipt_code": "120502",
        "affinityScore": "1"
    },
    {
        "career_code": "35101100",
        "cipt_code": "120503",
        "affinityScore": "1"
    },
    {
        "career_code": "35101200",
        "cipt_code": "120503",
        "affinityScore": "1"
    },
    {
        "career_code": "35201300",
        "cipt_code": "120503",
        "affinityScore": "1"
    },
    {
        "career_code": "35201400",
        "cipt_code": "120503",
        "affinityScore": "1"
    },
    {
        "career_code": "35201900",
        "cipt_code": "120503",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "120504",
        "affinityScore": "1"
    },
    {
        "career_code": "35101100",
        "cipt_code": "120504",
        "affinityScore": "1"
    },
    {
        "career_code": "35101200",
        "cipt_code": "120504",
        "affinityScore": "1"
    },
    {
        "career_code": "35201300",
        "cipt_code": "120504",
        "affinityScore": "1"
    },
    {
        "career_code": "35201200",
        "cipt_code": "120505",
        "affinityScore": "1"
    },
    {
        "career_code": "35201300",
        "cipt_code": "120505",
        "affinityScore": "1"
    },
    {
        "career_code": "35201900",
        "cipt_code": "120505",
        "affinityScore": "1"
    },
    {
        "career_code": "51302100",
        "cipt_code": "120506",
        "affinityScore": "1"
    },
    {
        "career_code": "51302300",
        "cipt_code": "120506",
        "affinityScore": "1"
    },
    {
        "career_code": "35101200",
        "cipt_code": "120507",
        "affinityScore": "1"
    },
    {
        "career_code": "35201200",
        "cipt_code": "120508",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "120509",
        "affinityScore": "1"
    },
    {
        "career_code": "19101200",
        "cipt_code": "120509",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "120509",
        "affinityScore": "1"
    },
    {
        "career_code": "35101100",
        "cipt_code": "120509",
        "affinityScore": "1"
    },
    {
        "career_code": "35201900",
        "cipt_code": "120509",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "120510",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "120510",
        "affinityScore": "1"
    },
    {
        "career_code": "33903100",
        "cipt_code": "120601",
        "affinityScore": "1"
    },
    {
        "career_code": "39101300",
        "cipt_code": "120601",
        "affinityScore": "1"
    },
    {
        "career_code": "43304100",
        "cipt_code": "120601",
        "affinityScore": "1"
    },
    {
        "career_code": "39101300",
        "cipt_code": "120602",
        "affinityScore": "1"
    },
    {
        "career_code": "39301100",
        "cipt_code": "120602",
        "affinityScore": "1"
    },
    {
        "career_code": "39601200",
        "cipt_code": "129999",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130101",
        "affinityScore": "1"
    },
    {
        "career_code": "25904200",
        "cipt_code": "130101",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "130101",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "130201",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130202",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "130202",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "130202",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130203",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "130203",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130299",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "130299",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130301",
        "affinityScore": "1"
    },
    {
        "career_code": "25903100",
        "cipt_code": "130301",
        "affinityScore": "1"
    },
    {
        "career_code": "11903100",
        "cipt_code": "130401",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130401",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "130401",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130401",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130402",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "130403",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130403",
        "affinityScore": "1"
    },
    {
        "career_code": "11903100",
        "cipt_code": "130404",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130404",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "130404",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130404",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "130406",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130406",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "130407",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130408",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130409",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130410",
        "affinityScore": "1"
    },
    {
        "career_code": "11903100",
        "cipt_code": "130411",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130411",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130411",
        "affinityScore": "1"
    },
    {
        "career_code": "11903100",
        "cipt_code": "130412",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130412",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "130412",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130412",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130413",
        "affinityScore": "1"
    },
    {
        "career_code": "11903100",
        "cipt_code": "130414",
        "affinityScore": "1"
    },
    {
        "career_code": "11903200",
        "cipt_code": "130414",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "130499",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "130501",
        "affinityScore": "1"
    },
    {
        "career_code": "25402200",
        "cipt_code": "130501",
        "affinityScore": "1"
    },
    {
        "career_code": "25903100",
        "cipt_code": "130501",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "130601",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "130601",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130601",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "130603",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "130603",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "130603",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130603",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "130604",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "130604",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "130604",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130604",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "130607",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "130607",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "130607",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130607",
        "affinityScore": "1"
    },
    {
        "career_code": "25909900",
        "cipt_code": "130607",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "130608",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "130608",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "130608",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "130699",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "130699",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "130699",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130699",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "130901",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "131001",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "131003",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131005",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131006",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131007",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131008",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131009",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131011",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131012",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131013",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131014",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131015",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131015",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25205100",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131016",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131017",
        "affinityScore": "1"
    },
    {
        "career_code": "25205500",
        "cipt_code": "131017",
        "affinityScore": "1"
    },
    {
        "career_code": "25205600",
        "cipt_code": "131017",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131018",
        "affinityScore": "1"
    },
    {
        "career_code": "25205700",
        "cipt_code": "131018",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131019",
        "affinityScore": "1"
    },
    {
        "career_code": "25205800",
        "cipt_code": "131019",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131099",
        "affinityScore": "1"
    },
    {
        "career_code": "25205900",
        "cipt_code": "131099",
        "affinityScore": "1"
    },
    {
        "career_code": "21101200",
        "cipt_code": "131101",
        "affinityScore": "1"
    },
    {
        "career_code": "21101200",
        "cipt_code": "131102",
        "affinityScore": "1"
    },
    {
        "career_code": "39904100",
        "cipt_code": "131102",
        "affinityScore": "1"
    },
    {
        "career_code": "21101200",
        "cipt_code": "131199",
        "affinityScore": "1"
    },
    {
        "career_code": "39904100",
        "cipt_code": "131199",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "131201",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "131201",
        "affinityScore": "1"
    },
    {
        "career_code": "25302100",
        "cipt_code": "131201",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131202",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131202",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131203",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131203",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131203",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131205",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131205",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131206",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131206",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131206",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131206",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131206",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131206",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "131207",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "131208",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131209",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131209",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131209",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131210",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131210",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131210",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131210",
        "affinityScore": "1"
    },
    {
        "career_code": "25904200",
        "cipt_code": "131210",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "131210",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25302100",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "131211",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131212",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131212",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131212",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131212",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131212",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131213",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131213",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131213",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131213",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131214",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "131301",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131301",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131301",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131301",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131301",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131302",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "131302",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131302",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131302",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "131303",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131303",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131303",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131303",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131303",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131304",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131304",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "131304",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131305",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "131305",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131305",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131305",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131306",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "131306",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131306",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131306",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131307",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131307",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131307",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131308",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "131308",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131308",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131308",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131308",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131308",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131309",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131309",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131309",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131309",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131309",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131309",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "131310",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131310",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131310",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131310",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131310",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "131311",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131311",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131311",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131311",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131312",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "131312",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131312",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131312",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131314",
        "affinityScore": "1"
    },
    {
        "career_code": "25119300",
        "cipt_code": "131314",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131314",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131314",
        "affinityScore": "1"
    },
    {
        "career_code": "27202200",
        "cipt_code": "131314",
        "affinityScore": "1"
    },
    {
        "career_code": "39903100",
        "cipt_code": "131314",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131315",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131315",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131315",
        "affinityScore": "1"
    },
    {
        "career_code": "25104100",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131316",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131317",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131317",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131317",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131318",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131318",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131319",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131319",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131319",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131319",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131320",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131320",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131320",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131320",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "131321",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131321",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131321",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131321",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "131322",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131322",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131322",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131322",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "131323",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131323",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131323",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131323",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131324",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "131324",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131324",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131324",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131325",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "131325",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131325",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131325",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131326",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "131326",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131326",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131326",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "131327",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "131327",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131327",
        "affinityScore": "1"
    },
    {
        "career_code": "25202300",
        "cipt_code": "131327",
        "affinityScore": "1"
    },
    {
        "career_code": "25203200",
        "cipt_code": "131327",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131328",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "131328",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131328",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131328",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "131329",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131329",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131329",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131330",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "131330",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131330",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131330",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131331",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131331",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131331",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "131332",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131332",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131332",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131332",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "131333",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131333",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131333",
        "affinityScore": "1"
    },
    {
        "career_code": "25402200",
        "cipt_code": "131334",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "131335",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131335",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "131337",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131337",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131337",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131337",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131338",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131338",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131338",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131338",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131339",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131339",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131339",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131339",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "131399",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "131399",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131401",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131401",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131401",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131401",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131401",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "131401",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131402",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131402",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131402",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131402",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131402",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "131402",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "131499",
        "affinityScore": "1"
    },
    {
        "career_code": "25201200",
        "cipt_code": "131499",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "131499",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "131499",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "131499",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "131499",
        "affinityScore": "1"
    },
    {
        "career_code": "25904200",
        "cipt_code": "131501",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "131501",
        "affinityScore": "1"
    },
    {
        "career_code": "25904900",
        "cipt_code": "131501",
        "affinityScore": "1"
    },
    {
        "career_code": "25301100",
        "cipt_code": "131502",
        "affinityScore": "1"
    },
    {
        "career_code": "25904900",
        "cipt_code": "131502",
        "affinityScore": "1"
    },
    {
        "career_code": "25904200",
        "cipt_code": "131599",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "131599",
        "affinityScore": "1"
    },
    {
        "career_code": "25904400",
        "cipt_code": "131599",
        "affinityScore": "1"
    },
    {
        "career_code": "25904900",
        "cipt_code": "131599",
        "affinityScore": "1"
    },
    {
        "career_code": "25909900",
        "cipt_code": "131599",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "139999",
        "affinityScore": "1"
    },
    {
        "career_code": "25309900",
        "cipt_code": "139999",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140101",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "140101",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140101",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "140103",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140201",
        "affinityScore": "1"
    },
    {
        "career_code": "17201100",
        "cipt_code": "140201",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140201",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140202",
        "affinityScore": "1"
    },
    {
        "career_code": "17201100",
        "cipt_code": "140202",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "140202",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140202",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140299",
        "affinityScore": "1"
    },
    {
        "career_code": "17201100",
        "cipt_code": "140299",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140299",
        "affinityScore": "1"
    },
    {
        "career_code": "49209100",
        "cipt_code": "140299",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140301",
        "affinityScore": "1"
    },
    {
        "career_code": "17202100",
        "cipt_code": "140301",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140301",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140401",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "140401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "140401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140401",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140501",
        "affinityScore": "1"
    },
    {
        "career_code": "17203100",
        "cipt_code": "140501",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140601",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "140601",
        "affinityScore": "1"
    },
    {
        "career_code": "17213100",
        "cipt_code": "140601",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140601",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140701",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "140701",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140701",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140702",
        "affinityScore": "1"
    },
    {
        "career_code": "17203100",
        "cipt_code": "140702",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "140702",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "140702",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140702",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140799",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "140799",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140799",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140801",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "140801",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140801",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "17208100",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "17215100",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "17217100",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140802",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140803",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "140803",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140803",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140804",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "140804",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140804",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140805",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "140805",
        "affinityScore": "1"
    },
    {
        "career_code": "17208100",
        "cipt_code": "140805",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "140805",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140805",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140899",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "140899",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140899",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "17206100",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140901",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140902",
        "affinityScore": "1"
    },
    {
        "career_code": "17206100",
        "cipt_code": "140902",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140902",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140903",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "140903",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "140903",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "140903",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140903",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "140999",
        "affinityScore": "1"
    },
    {
        "career_code": "15124100",
        "cipt_code": "140999",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "140999",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141001",
        "affinityScore": "1"
    },
    {
        "career_code": "17201100",
        "cipt_code": "141001",
        "affinityScore": "1"
    },
    {
        "career_code": "17206100",
        "cipt_code": "141001",
        "affinityScore": "1"
    },
    {
        "career_code": "17207100",
        "cipt_code": "141001",
        "affinityScore": "1"
    },
    {
        "career_code": "17207200",
        "cipt_code": "141001",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141001",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141003",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "141003",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141003",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141004",
        "affinityScore": "1"
    },
    {
        "career_code": "17207200",
        "cipt_code": "141004",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "141004",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141004",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141099",
        "affinityScore": "1"
    },
    {
        "career_code": "17207100",
        "cipt_code": "141099",
        "affinityScore": "1"
    },
    {
        "career_code": "17207200",
        "cipt_code": "141099",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141099",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141101",
        "affinityScore": "1"
    },
    {
        "career_code": "17214100",
        "cipt_code": "141101",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "141101",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141101",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141201",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "141201",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "141201",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "141201",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141201",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141301",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "141301",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141301",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141401",
        "affinityScore": "1"
    },
    {
        "career_code": "17208100",
        "cipt_code": "141401",
        "affinityScore": "1"
    },
    {
        "career_code": "17211100",
        "cipt_code": "141401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141401",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141801",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "141801",
        "affinityScore": "1"
    },
    {
        "career_code": "17213100",
        "cipt_code": "141801",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141801",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "141901",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "141901",
        "affinityScore": "1"
    },
    {
        "career_code": "17201100",
        "cipt_code": "141901",
        "affinityScore": "1"
    },
    {
        "career_code": "17214100",
        "cipt_code": "141901",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "141901",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142001",
        "affinityScore": "1"
    },
    {
        "career_code": "17213100",
        "cipt_code": "142001",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142001",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142101",
        "affinityScore": "1"
    },
    {
        "career_code": "17215100",
        "cipt_code": "142101",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142101",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142201",
        "affinityScore": "1"
    },
    {
        "career_code": "17212100",
        "cipt_code": "142201",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142201",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142301",
        "affinityScore": "1"
    },
    {
        "career_code": "17216100",
        "cipt_code": "142301",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142301",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142401",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "142401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142401",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142501",
        "affinityScore": "1"
    },
    {
        "career_code": "17217100",
        "cipt_code": "142501",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142701",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "142701",
        "affinityScore": "1"
    },
    {
        "career_code": "17211200",
        "cipt_code": "142701",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "142701",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142701",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "142801",
        "affinityScore": "1"
    },
    {
        "career_code": "17213100",
        "cipt_code": "142801",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "142801",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143201",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "143201",
        "affinityScore": "1"
    },
    {
        "career_code": "17213100",
        "cipt_code": "143201",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143201",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143301",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "143301",
        "affinityScore": "1"
    },
    {
        "career_code": "17205100",
        "cipt_code": "143301",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "143301",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143301",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143401",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "143401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143401",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "143501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143501",
        "affinityScore": "1"
    },
    {
        "career_code": "17211200",
        "cipt_code": "143501",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143601",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "143601",
        "affinityScore": "1"
    },
    {
        "career_code": "17211200",
        "cipt_code": "143601",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "143601",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143601",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "143701",
        "affinityScore": "1"
    },
    {
        "career_code": "15203100",
        "cipt_code": "143701",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143701",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143801",
        "affinityScore": "1"
    },
    {
        "career_code": "17102100",
        "cipt_code": "143801",
        "affinityScore": "1"
    },
    {
        "career_code": "17102200",
        "cipt_code": "143801",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "143801",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143801",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "143901",
        "affinityScore": "1"
    },
    {
        "career_code": "17215100",
        "cipt_code": "143901",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "143901",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "143901",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144001",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "144001",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144001",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144001",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144101",
        "affinityScore": "1"
    },
    {
        "career_code": "17207100",
        "cipt_code": "144101",
        "affinityScore": "1"
    },
    {
        "career_code": "17214100",
        "cipt_code": "144101",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144101",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144101",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144201",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144201",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144201",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144301",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "144301",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144301",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144301",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144401",
        "affinityScore": "1"
    },
    {
        "career_code": "17204100",
        "cipt_code": "144401",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144401",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144401",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144501",
        "affinityScore": "1"
    },
    {
        "career_code": "17203100",
        "cipt_code": "144501",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144501",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144701",
        "affinityScore": "1"
    },
    {
        "career_code": "17206100",
        "cipt_code": "144701",
        "affinityScore": "1"
    },
    {
        "career_code": "17207100",
        "cipt_code": "144701",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144701",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144701",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144801",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144801",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144801",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144802",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144802",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144802",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "144899",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "144899",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "144899",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "149999",
        "affinityScore": "1"
    },
    {
        "career_code": "17211100",
        "cipt_code": "149999",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "149999",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "149999",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "150000",
        "affinityScore": "1"
    },
    {
        "career_code": "17302200",
        "cipt_code": "150000",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150000",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150000",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150001",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "150001",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150001",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "150101",
        "affinityScore": "1"
    },
    {
        "career_code": "17302200",
        "cipt_code": "150101",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150101",
        "affinityScore": "1"
    },
    {
        "career_code": "17302200",
        "cipt_code": "150201",
        "affinityScore": "1"
    },
    {
        "career_code": "53604100",
        "cipt_code": "150201",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "150303",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "150303",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150303",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150303",
        "affinityScore": "1"
    },
    {
        "career_code": "17302800",
        "cipt_code": "150303",
        "affinityScore": "1"
    },
    {
        "career_code": "49209500",
        "cipt_code": "150303",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150304",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150305",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "150306",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150306",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150307",
        "affinityScore": "1"
    },
    {
        "career_code": "27209100",
        "cipt_code": "150307",
        "affinityScore": "1"
    },
    {
        "career_code": "27401400",
        "cipt_code": "150307",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150399",
        "affinityScore": "1"
    },
    {
        "career_code": "17302800",
        "cipt_code": "150401",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150401",
        "affinityScore": "1"
    },
    {
        "career_code": "49906200",
        "cipt_code": "150401",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "150403",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150403",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150404",
        "affinityScore": "1"
    },
    {
        "career_code": "17302800",
        "cipt_code": "150404",
        "affinityScore": "1"
    },
    {
        "career_code": "49906900",
        "cipt_code": "150404",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150405",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150406",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150406",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150407",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150499",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150501",
        "affinityScore": "1"
    },
    {
        "career_code": "49902100",
        "cipt_code": "150501",
        "affinityScore": "1"
    },
    {
        "career_code": "17302500",
        "cipt_code": "150506",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "150506",
        "affinityScore": "1"
    },
    {
        "career_code": "51803100",
        "cipt_code": "150506",
        "affinityScore": "1"
    },
    {
        "career_code": "17302500",
        "cipt_code": "150507",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "150507",
        "affinityScore": "1"
    },
    {
        "career_code": "17302500",
        "cipt_code": "150508",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "150508",
        "affinityScore": "1"
    },
    {
        "career_code": "47404100",
        "cipt_code": "150508",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150599",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150607",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150611",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "150612",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "150613",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150614",
        "affinityScore": "1"
    },
    {
        "career_code": "51412100",
        "cipt_code": "150614",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150615",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "150616",
        "affinityScore": "1"
    },
    {
        "career_code": "51914100",
        "cipt_code": "150616",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150617",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "150699",
        "affinityScore": "1"
    },
    {
        "career_code": "19501100",
        "cipt_code": "150701",
        "affinityScore": "1"
    },
    {
        "career_code": "51906100",
        "cipt_code": "150702",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "150703",
        "affinityScore": "1"
    },
    {
        "career_code": "19501100",
        "cipt_code": "150703",
        "affinityScore": "1"
    },
    {
        "career_code": "17302500",
        "cipt_code": "150704",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "150705",
        "affinityScore": "1"
    },
    {
        "career_code": "19501200",
        "cipt_code": "150705",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "150801",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "150801",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "150803",
        "affinityScore": "1"
    },
    {
        "career_code": "17302700",
        "cipt_code": "150803",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "150803",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "150805",
        "affinityScore": "1"
    },
    {
        "career_code": "17302400",
        "cipt_code": "150805",
        "affinityScore": "1"
    },
    {
        "career_code": "17302700",
        "cipt_code": "150805",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150806",
        "affinityScore": "1"
    },
    {
        "career_code": "49305100",
        "cipt_code": "150806",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150807",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "150807",
        "affinityScore": "1"
    },
    {
        "career_code": "17302700",
        "cipt_code": "150899",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "150901",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "150901",
        "affinityScore": "1"
    },
    {
        "career_code": "47501300",
        "cipt_code": "150901",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "150903",
        "affinityScore": "1"
    },
    {
        "career_code": "51809200",
        "cipt_code": "150903",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "150999",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "151001",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "151001",
        "affinityScore": "1"
    },
    {
        "career_code": "17302200",
        "cipt_code": "151001",
        "affinityScore": "1"
    },
    {
        "career_code": "17102100",
        "cipt_code": "151102",
        "affinityScore": "1"
    },
    {
        "career_code": "17102200",
        "cipt_code": "151102",
        "affinityScore": "1"
    },
    {
        "career_code": "17301900",
        "cipt_code": "151102",
        "affinityScore": "1"
    },
    {
        "career_code": "17303100",
        "cipt_code": "151102",
        "affinityScore": "1"
    },
    {
        "career_code": "17302700",
        "cipt_code": "151103",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151103",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "151201",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "151201",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "151202",
        "affinityScore": "1"
    },
    {
        "career_code": "17302300",
        "cipt_code": "151202",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151202",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151203",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "151204",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "151204",
        "affinityScore": "1"
    },
    {
        "career_code": "15125300",
        "cipt_code": "151204",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151204",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151299",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "151301",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "151301",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "151301",
        "affinityScore": "1"
    },
    {
        "career_code": "17301900",
        "cipt_code": "151301",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "151302",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "151302",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "151302",
        "affinityScore": "1"
    },
    {
        "career_code": "17301900",
        "cipt_code": "151302",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "151303",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "151304",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "151305",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "151306",
        "affinityScore": "1"
    },
    {
        "career_code": "17301100",
        "cipt_code": "151307",
        "affinityScore": "1"
    },
    {
        "career_code": "17301200",
        "cipt_code": "151307",
        "affinityScore": "1"
    },
    {
        "career_code": "17301300",
        "cipt_code": "151307",
        "affinityScore": "1"
    },
    {
        "career_code": "17301900",
        "cipt_code": "151307",
        "affinityScore": "1"
    },
    {
        "career_code": "17301900",
        "cipt_code": "151399",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151401",
        "affinityScore": "1"
    },
    {
        "career_code": "19405100",
        "cipt_code": "151401",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "151501",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "151501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "151501",
        "affinityScore": "1"
    },
    {
        "career_code": "17211200",
        "cipt_code": "151501",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "151501",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "151502",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "151502",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "151502",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "17211200",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "17302600",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "27102100",
        "cipt_code": "151503",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "151601",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151701",
        "affinityScore": "1"
    },
    {
        "career_code": "27102100",
        "cipt_code": "151701",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151702",
        "affinityScore": "1"
    },
    {
        "career_code": "49209500",
        "cipt_code": "151702",
        "affinityScore": "1"
    },
    {
        "career_code": "51801300",
        "cipt_code": "151702",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151703",
        "affinityScore": "1"
    },
    {
        "career_code": "47223100",
        "cipt_code": "151703",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151704",
        "affinityScore": "1"
    },
    {
        "career_code": "49908100",
        "cipt_code": "151704",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151705",
        "affinityScore": "1"
    },
    {
        "career_code": "51801300",
        "cipt_code": "151705",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151706",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "151799",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160101",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160102",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160103",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160103",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "160104",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160105",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160105",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "160199",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160201",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160300",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160300",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160300",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160301",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160301",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160301",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160302",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160302",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160302",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160303",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160303",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160303",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160304",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160304",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160399",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160399",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160399",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160400",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160400",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160401",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160402",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160402",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160402",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160404",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160404",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160405",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160405",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160406",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160406",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160407",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160407",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160408",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160408",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160409",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160409",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160410",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160410",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160499",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160499",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160500",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160500",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160500",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160501",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160501",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160501",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160502",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160502",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160503",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160503",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160504",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160504",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160505",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160505",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160506",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160506",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160599",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160599",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160599",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160601",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160700",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160700",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160701",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160701",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160702",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160702",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160704",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160704",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160705",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160705",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160706",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160706",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160707",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160707",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160799",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160799",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160801",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160801",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160900",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160900",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160900",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160901",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160901",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160901",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160902",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160902",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160902",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160904",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160904",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160905",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160905",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160905",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160906",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160906",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160907",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160907",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160908",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160908",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "160999",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "160999",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "160999",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161001",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161001",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161001",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161100",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161100",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161101",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161102",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161102",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161103",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161103",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161199",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161199",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161200",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161200",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161200",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161202",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161202",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161202",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161203",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161203",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161203",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161299",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161299",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161299",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161301",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161301",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161400",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161400",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161401",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161402",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161402",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161403",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161403",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161404",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161404",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161405",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161405",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161406",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161406",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161407",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161407",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161408",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161408",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161409",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161409",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161409",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161499",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161499",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161499",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161501",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161501",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161502",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161502",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161503",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161503",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161504",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161504",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161599",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161599",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161601",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161601",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161602",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "161602",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "161602",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161602",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161603",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161699",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "161801",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "161801",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "169999",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "169999",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "169999",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "190101",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190101",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190201",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190201",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190202",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "190202",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "190202",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "190202",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "190203",
        "affinityScore": "1"
    },
    {
        "career_code": "11202200",
        "cipt_code": "190203",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "190203",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190203",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "190203",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190299",
        "affinityScore": "1"
    },
    {
        "career_code": "13205200",
        "cipt_code": "190401",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190401",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190401",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190402",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190402",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190403",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190403",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190499",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190499",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190501",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "190501",
        "affinityScore": "1"
    },
    {
        "career_code": "29205100",
        "cipt_code": "190501",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190504",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "190504",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "190505",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190505",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "190505",
        "affinityScore": "1"
    },
    {
        "career_code": "35101200",
        "cipt_code": "190505",
        "affinityScore": "1"
    },
    {
        "career_code": "35201200",
        "cipt_code": "190505",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190599",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "190599",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190601",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190601",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "190604",
        "affinityScore": "1"
    },
    {
        "career_code": "13112100",
        "cipt_code": "190604",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "190604",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190605",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "190699",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190701",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "190702",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "190702",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190702",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190704",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190704",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "25904200",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "39901100",
        "cipt_code": "190706",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190707",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190708",
        "affinityScore": "1"
    },
    {
        "career_code": "25201100",
        "cipt_code": "190708",
        "affinityScore": "1"
    },
    {
        "career_code": "39901100",
        "cipt_code": "190709",
        "affinityScore": "1"
    },
    {
        "career_code": "21109300",
        "cipt_code": "190710",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "190710",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "190711",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "190711",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190711",
        "affinityScore": "1"
    },
    {
        "career_code": "39901100",
        "cipt_code": "190711",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "190712",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190712",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190901",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "190901",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190902",
        "affinityScore": "1"
    },
    {
        "career_code": "27102200",
        "cipt_code": "190902",
        "affinityScore": "1"
    },
    {
        "career_code": "51609200",
        "cipt_code": "190902",
        "affinityScore": "1"
    },
    {
        "career_code": "19203200",
        "cipt_code": "190904",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "190904",
        "affinityScore": "1"
    },
    {
        "career_code": "27102200",
        "cipt_code": "190904",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "190904",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "190905",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "190905",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "190905",
        "affinityScore": "1"
    },
    {
        "career_code": "27102200",
        "cipt_code": "190906",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "191001",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "191001",
        "affinityScore": "1"
    },
    {
        "career_code": "23201100",
        "cipt_code": "220000",
        "affinityScore": "1"
    },
    {
        "career_code": "23209900",
        "cipt_code": "220000",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220101",
        "affinityScore": "1"
    },
    {
        "career_code": "23101200",
        "cipt_code": "220101",
        "affinityScore": "1"
    },
    {
        "career_code": "23102100",
        "cipt_code": "220101",
        "affinityScore": "1"
    },
    {
        "career_code": "23102200",
        "cipt_code": "220101",
        "affinityScore": "1"
    },
    {
        "career_code": "23102300",
        "cipt_code": "220101",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220101",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220201",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220201",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220202",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220203",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220203",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220204",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220204",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220205",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220205",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220206",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220206",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220207",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220207",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220208",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220208",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220209",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220209",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220210",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220210",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220211",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220211",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220212",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220212",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220213",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220213",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220214",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220214",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220215",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220215",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220216",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220216",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220217",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220217",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220218",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220218",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220219",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220219",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220220",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220220",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220221",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220221",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220222",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220222",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220223",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220223",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220224",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220224",
        "affinityScore": "1"
    },
    {
        "career_code": "23101100",
        "cipt_code": "220299",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "220299",
        "affinityScore": "1"
    },
    {
        "career_code": "43601200",
        "cipt_code": "220301",
        "affinityScore": "1"
    },
    {
        "career_code": "23201100",
        "cipt_code": "220302",
        "affinityScore": "1"
    },
    {
        "career_code": "23209300",
        "cipt_code": "220302",
        "affinityScore": "1"
    },
    {
        "career_code": "23209900",
        "cipt_code": "220302",
        "affinityScore": "1"
    },
    {
        "career_code": "27309200",
        "cipt_code": "220303",
        "affinityScore": "1"
    },
    {
        "career_code": "23209900",
        "cipt_code": "220304",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "220304",
        "affinityScore": "1"
    },
    {
        "career_code": "27309200",
        "cipt_code": "220304",
        "affinityScore": "1"
    },
    {
        "career_code": "27309200",
        "cipt_code": "220305",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "230101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "230101",
        "affinityScore": "1"
    },
    {
        "career_code": "43908100",
        "cipt_code": "230101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231301",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "231301",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231301",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "231301",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231301",
        "affinityScore": "1"
    },
    {
        "career_code": "43908100",
        "cipt_code": "231301",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231302",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "231302",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231302",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231302",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231303",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "231303",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231303",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "231303",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231303",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231304",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "231304",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231304",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231304",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231399",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231399",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231399",
        "affinityScore": "1"
    },
    {
        "career_code": "43908100",
        "cipt_code": "231399",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231401",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231401",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231402",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231403",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231404",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231405",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231405",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231405",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "231499",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "231499",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "231499",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "239999",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "240101",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "240102",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "240103",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "250101",
        "affinityScore": "1"
    },
    {
        "career_code": "25108200",
        "cipt_code": "250101",
        "affinityScore": "1"
    },
    {
        "career_code": "25402200",
        "cipt_code": "250101",
        "affinityScore": "1"
    },
    {
        "career_code": "25108200",
        "cipt_code": "250102",
        "affinityScore": "1"
    },
    {
        "career_code": "25402200",
        "cipt_code": "250102",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "250103",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "250103",
        "affinityScore": "1"
    },
    {
        "career_code": "25402200",
        "cipt_code": "250199",
        "affinityScore": "1"
    },
    {
        "career_code": "25403100",
        "cipt_code": "250301",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19401200",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "260101",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260102",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260102",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260102",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260202",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260202",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260202",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "260202",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260202",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260202",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260203",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260203",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260203",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260203",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260204",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260204",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260204",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260204",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260204",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260205",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260205",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260205",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260205",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260206",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260206",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260206",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260207",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260207",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260207",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260207",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260207",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260208",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260208",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260208",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260209",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260209",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260209",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260210",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260210",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260210",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260210",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260299",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260299",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260299",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260301",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "260301",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260301",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260301",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260305",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "260305",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260305",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260305",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260307",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "260307",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260307",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260307",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "260308",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260308",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260399",
        "affinityScore": "1"
    },
    {
        "career_code": "19101300",
        "cipt_code": "260399",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260399",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260399",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104100",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "29201100",
        "cipt_code": "260401",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260403",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260403",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260403",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260403",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "260403",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260404",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260404",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260404",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "260404",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260406",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260406",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260406",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260406",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260406",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260407",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260407",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260407",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260499",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260499",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260499",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260499",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260499",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260502",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260502",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "260502",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260502",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260502",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260503",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260503",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260503",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260503",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260503",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "260503",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260504",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260504",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260504",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260504",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260504",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260505",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260505",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260505",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260505",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260505",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260506",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260506",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260507",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260507",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260507",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260507",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260507",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260508",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260508",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260508",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260508",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260508",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260508",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "260509",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260509",
        "affinityScore": "1"
    },
    {
        "career_code": "19104100",
        "cipt_code": "260509",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260509",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260599",
        "affinityScore": "1"
    },
    {
        "career_code": "19102200",
        "cipt_code": "260599",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260599",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260701",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "260701",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260701",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260701",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260702",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "260702",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260702",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260702",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260707",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "260707",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260707",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260707",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "260708",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260708",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "260709",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260709",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260799",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "260799",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260799",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260801",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "260801",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260801",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "260801",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260802",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260802",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260802",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "260802",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260803",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260803",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260804",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260804",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260804",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260805",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260805",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260805",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260806",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260806",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "260806",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260807",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260807",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260807",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "260807",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260899",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260899",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260899",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "260899",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260901",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260901",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260902",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260902",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260903",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260903",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260904",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260904",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260905",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260905",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260907",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260907",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260908",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260908",
        "affinityScore": "1"
    },
    {
        "career_code": "29112800",
        "cipt_code": "260908",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260909",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260909",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260910",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "260910",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260910",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260910",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260911",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260911",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "260912",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260912",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260912",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "260913",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260913",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "260913",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "260913",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "260999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "260999",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261001",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261001",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261001",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261001",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261001",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261002",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261002",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261003",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261003",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261004",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261004",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261004",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "261004",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261004",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261004",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261005",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "261005",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261005",
        "affinityScore": "1"
    },
    {
        "career_code": "17302500",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "19501100",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "19501200",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261006",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261007",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261007",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261099",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261099",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261101",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "261101",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261101",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261101",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261102",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "261103",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "261103",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "261103",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "261103",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261104",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261199",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "261199",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "261199",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "261199",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261199",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261199",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261201",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261201",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261201",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "25104300",
        "cipt_code": "261301",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261302",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "261302",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261302",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "261302",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261302",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261303",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "261303",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261303",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261303",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261304",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "261304",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261304",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "261305",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261305",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "261305",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261305",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261306",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261306",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261307",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "261307",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261307",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "261307",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261308",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261308",
        "affinityScore": "1"
    },
    {
        "career_code": "19104100",
        "cipt_code": "261309",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261309",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261309",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261310",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261310",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "261310",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261310",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "261310",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261311",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "261311",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261311",
        "affinityScore": "1"
    },
    {
        "career_code": "19104100",
        "cipt_code": "261311",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "261311",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261399",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261399",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "261399",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "261399",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261399",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "261399",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261401",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261401",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261501",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261501",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "261501",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261501",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261502",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261502",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261502",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261502",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261503",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261503",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261503",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261503",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261504",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261504",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261504",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261504",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "261599",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "261599",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "261599",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "261599",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "269999",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "269999",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "269999",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "269999",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "270101",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270102",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270102",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270102",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270103",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270103",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270103",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270104",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270104",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270104",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270105",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270105",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270105",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270199",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270199",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270199",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270301",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270303",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270303",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270303",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270303",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270304",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "13209900",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270305",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270306",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270306",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270306",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270306",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "270306",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270306",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270399",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270399",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270399",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "270399",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270399",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270501",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270501",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270501",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270501",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "270501",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270501",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270502",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270502",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270502",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270502",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270502",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270503",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270503",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "270503",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270503",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270503",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270503",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270599",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270599",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270599",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270599",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "270601",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "279999",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "279999",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "279999",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "279999",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "279999",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280503",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280504",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280505",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "280506",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "280506",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280599",
        "affinityScore": "1"
    },
    {
        "career_code": "55301900",
        "cipt_code": "280599",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280601",
        "affinityScore": "1"
    },
    {
        "career_code": "55101600",
        "cipt_code": "280602",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280602",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "280604",
        "affinityScore": "1"
    },
    {
        "career_code": "55101400",
        "cipt_code": "280605",
        "affinityScore": "1"
    },
    {
        "career_code": "55301400",
        "cipt_code": "280605",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "290201",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "290201",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "290202",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "290202",
        "affinityScore": "1"
    },
    {
        "career_code": "17102100",
        "cipt_code": "290203",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "290203",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "290203",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "290203",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "290203",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290204",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290204",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290205",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290205",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290206",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290206",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290207",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290207",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290299",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290299",
        "affinityScore": "1"
    },
    {
        "career_code": "55101900",
        "cipt_code": "290301",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "290303",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "290306",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "290307",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "290401",
        "affinityScore": "1"
    },
    {
        "career_code": "55301200",
        "cipt_code": "290401",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "290402",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "290404",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "290404",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290405",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290405",
        "affinityScore": "1"
    },
    {
        "career_code": "55101500",
        "cipt_code": "290406",
        "affinityScore": "1"
    },
    {
        "career_code": "55301500",
        "cipt_code": "290406",
        "affinityScore": "1"
    },
    {
        "career_code": "55101400",
        "cipt_code": "290407",
        "affinityScore": "1"
    },
    {
        "career_code": "55301400",
        "cipt_code": "290407",
        "affinityScore": "1"
    },
    {
        "career_code": "55301400",
        "cipt_code": "290408",
        "affinityScore": "1"
    },
    {
        "career_code": "17302900",
        "cipt_code": "290409",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "300101",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "300101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "300101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "300501",
        "affinityScore": "1"
    },
    {
        "career_code": "23102200",
        "cipt_code": "300501",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "300501",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "300601",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "300601",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "300801",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "301001",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "301001",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "301001",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "301001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "301001",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "301101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "301101",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "301101",
        "affinityScore": "1"
    },
    {
        "career_code": "25111300",
        "cipt_code": "301101",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "301201",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "301201",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "301201",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "301201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "301202",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "301202",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "301202",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "301202",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "301299",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "301299",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "301299",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "301299",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "301301",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "301301",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "301401",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "301401",
        "affinityScore": "1"
    },
    {
        "career_code": "25401200",
        "cipt_code": "301401",
        "affinityScore": "1"
    },
    {
        "career_code": "25401300",
        "cipt_code": "301401",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "301501",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "301501",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "301601",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "301701",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "301801",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "301801",
        "affinityScore": "1"
    },
    {
        "career_code": "19209900",
        "cipt_code": "301801",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "301801",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "25119200",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "25902100",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "29205100",
        "cipt_code": "301901",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "302001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "302001",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "302101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "302101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "302101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "302101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "302201",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "302201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "302201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "302201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "302201",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "302202",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "302202",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "302202",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "302202",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "302299",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "302299",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "302299",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "302299",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "302299",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "302301",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "302301",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "302501",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "302501",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "302502",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "302502",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "302502",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "302502",
        "affinityScore": "1"
    },
    {
        "career_code": "25302100",
        "cipt_code": "302502",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "302599",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "302599",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "302601",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "302601",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "302601",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "302701",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "302701",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "302701",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "302701",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "302701",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "302701",
        "affinityScore": "1"
    },
    {
        "career_code": "13107500",
        "cipt_code": "302801",
        "affinityScore": "1"
    },
    {
        "career_code": "23102200",
        "cipt_code": "302801",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "302801",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "302801",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "302901",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "302901",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "303001",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "303101",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "303101",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "303101",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "303101",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "303101",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "19102300",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "19209900",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "303201",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "303301",
        "affinityScore": "1"
    },
    {
        "career_code": "11901300",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "19101100",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "39201100",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "39202100",
        "cipt_code": "303401",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "303501",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "303501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "303501",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "303501",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "303601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "303601",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "303601",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "303701",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "303701",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "303701",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "303801",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "303801",
        "affinityScore": "1"
    },
    {
        "career_code": "19204300",
        "cipt_code": "303801",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "303801",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "303801",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "303801",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "303901",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "304001",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "19204300",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "304101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "304201",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "304201",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "304201",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "304201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "304201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "304201",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "304301",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "304301",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "304301",
        "affinityScore": "1"
    },
    {
        "career_code": "25104200",
        "cipt_code": "304301",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "304301",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "19103100",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "304401",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "27309100",
        "cipt_code": "304501",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "304601",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "304701",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "304701",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "304701",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "304701",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "304701",
        "affinityScore": "1"
    },
    {
        "career_code": "25112400",
        "cipt_code": "304701",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "304801",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "304801",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "304801",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "304801",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "304901",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "304901",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "304901",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "304901",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "304901",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "304901",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "305001",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "305001",
        "affinityScore": "1"
    },
    {
        "career_code": "15209900",
        "cipt_code": "305001",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "305001",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "305001",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "305001",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "305101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "305201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "305201",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "305201",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "305201",
        "affinityScore": "1"
    },
    {
        "career_code": "25401200",
        "cipt_code": "305201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "305202",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "305202",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "305202",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "305202",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "305202",
        "affinityScore": "1"
    },
    {
        "career_code": "25401200",
        "cipt_code": "305202",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "305203",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "305203",
        "affinityScore": "1"
    },
    {
        "career_code": "25112300",
        "cipt_code": "305203",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "305203",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "305203",
        "affinityScore": "1"
    },
    {
        "career_code": "25401200",
        "cipt_code": "305203",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "39403100",
        "cipt_code": "305301",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "15125200",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "307001",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "307099",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "307099",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "307099",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "307099",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307099",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "307099",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "307101",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "307101",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "307101",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307101",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "307101",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "307102",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "307102",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "307102",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307102",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "307103",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "307103",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307103",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "307103",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "307104",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "307104",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "307104",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307104",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "307104",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "307199",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "307199",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "307199",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "307199",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "307199",
        "affinityScore": "1"
    },
    {
        "career_code": "25119300",
        "cipt_code": "310101",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "310301",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "310301",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "310301",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "310302",
        "affinityScore": "1"
    },
    {
        "career_code": "37101200",
        "cipt_code": "310302",
        "affinityScore": "1"
    },
    {
        "career_code": "37301100",
        "cipt_code": "310302",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "310399",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "310399",
        "affinityScore": "1"
    },
    {
        "career_code": "25119300",
        "cipt_code": "310501",
        "affinityScore": "1"
    },
    {
        "career_code": "27202100",
        "cipt_code": "310501",
        "affinityScore": "1"
    },
    {
        "career_code": "27202200",
        "cipt_code": "310501",
        "affinityScore": "1"
    },
    {
        "career_code": "39903100",
        "cipt_code": "310501",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "310504",
        "affinityScore": "1"
    },
    {
        "career_code": "25119300",
        "cipt_code": "310504",
        "affinityScore": "1"
    },
    {
        "career_code": "27202200",
        "cipt_code": "310504",
        "affinityScore": "1"
    },
    {
        "career_code": "39903100",
        "cipt_code": "310504",
        "affinityScore": "1"
    },
    {
        "career_code": "29112800",
        "cipt_code": "310505",
        "affinityScore": "1"
    },
    {
        "career_code": "29909100",
        "cipt_code": "310507",
        "affinityScore": "1"
    },
    {
        "career_code": "39903100",
        "cipt_code": "310507",
        "affinityScore": "1"
    },
    {
        "career_code": "25119300",
        "cipt_code": "310508",
        "affinityScore": "1"
    },
    {
        "career_code": "39101400",
        "cipt_code": "310601",
        "affinityScore": "1"
    },
    {
        "career_code": "39903200",
        "cipt_code": "310601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380001",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380101",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "380102",
        "affinityScore": "1"
    },
    {
        "career_code": "15202100",
        "cipt_code": "380102",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "380102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380103",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380104",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380199",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380202",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380203",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380204",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "380205",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "380206",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "380207",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "380208",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "380209",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "389999",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390201",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390301",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390301",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390302",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390399",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390501",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "390501",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390502",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390502",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "390502",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390599",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390599",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390601",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390602",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390602",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390604",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390604",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390605",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390605",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390699",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390699",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390699",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "390701",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "390701",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390701",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390701",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390701",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390701",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390702",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390702",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390703",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390703",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390703",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390704",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390704",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390705",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390705",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "390706",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390706",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390706",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390706",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "390799",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "390799",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "390799",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390799",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "390801",
        "affinityScore": "1"
    },
    {
        "career_code": "13209900",
        "cipt_code": "390801",
        "affinityScore": "1"
    },
    {
        "career_code": "21209900",
        "cipt_code": "390802",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "390802",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "390802",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "400101",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400201",
        "affinityScore": "1"
    },
    {
        "career_code": "19201100",
        "cipt_code": "400201",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400201",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400202",
        "affinityScore": "1"
    },
    {
        "career_code": "19201100",
        "cipt_code": "400202",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400202",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400202",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400203",
        "affinityScore": "1"
    },
    {
        "career_code": "19201100",
        "cipt_code": "400203",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400203",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400299",
        "affinityScore": "1"
    },
    {
        "career_code": "19201100",
        "cipt_code": "400299",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400299",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400299",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400401",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "400401",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "400401",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400401",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400402",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "400402",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400402",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400403",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "400403",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400403",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400404",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "400404",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400404",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400499",
        "affinityScore": "1"
    },
    {
        "career_code": "19202100",
        "cipt_code": "400499",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400499",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "19401300",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "400501",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400502",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400502",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "400502",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400502",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400503",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400503",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "400503",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400503",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400504",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400504",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "400504",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400504",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400506",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400506",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400506",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400507",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400507",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400507",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400508",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400508",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400508",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400508",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "25105300",
        "cipt_code": "400509",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400510",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400510",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "400510",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400510",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400511",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400511",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400511",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400512",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "400512",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "400512",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "400512",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400512",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400512",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400599",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "400599",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400599",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400601",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400601",
        "affinityScore": "1"
    },
    {
        "career_code": "19204300",
        "cipt_code": "400601",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "400601",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400601",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400602",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400602",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400602",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "400602",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400603",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400603",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400603",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400604",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400604",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400604",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400605",
        "affinityScore": "1"
    },
    {
        "career_code": "19204300",
        "cipt_code": "400605",
        "affinityScore": "1"
    },
    {
        "career_code": "19404400",
        "cipt_code": "400605",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400605",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400606",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400606",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400606",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400607",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400607",
        "affinityScore": "1"
    },
    {
        "career_code": "19204300",
        "cipt_code": "400607",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400607",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400699",
        "affinityScore": "1"
    },
    {
        "career_code": "19204200",
        "cipt_code": "400699",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "400699",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400801",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400801",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400801",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "400801",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400802",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400802",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400802",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400804",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400804",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400804",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400805",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400805",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400805",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400806",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400806",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400806",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400807",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400807",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400807",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400808",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400808",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400808",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400809",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400809",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400809",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400810",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400810",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400810",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "400899",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "400899",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "400899",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "401001",
        "affinityScore": "1"
    },
    {
        "career_code": "19203200",
        "cipt_code": "401001",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "401001",
        "affinityScore": "1"
    },
    {
        "career_code": "25103200",
        "cipt_code": "401001",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "401002",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "401002",
        "affinityScore": "1"
    },
    {
        "career_code": "19203200",
        "cipt_code": "401002",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "401002",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "401002",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "401099",
        "affinityScore": "1"
    },
    {
        "career_code": "19203200",
        "cipt_code": "401099",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "401099",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "401101",
        "affinityScore": "1"
    },
    {
        "career_code": "19201100",
        "cipt_code": "401101",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "401101",
        "affinityScore": "1"
    },
    {
        "career_code": "25105100",
        "cipt_code": "401101",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "401101",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "409999",
        "affinityScore": "1"
    },
    {
        "career_code": "19209900",
        "cipt_code": "409999",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "409999",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "410000",
        "affinityScore": "1"
    },
    {
        "career_code": "19404400",
        "cipt_code": "410000",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "410000",
        "affinityScore": "1"
    },
    {
        "career_code": "19402100",
        "cipt_code": "410101",
        "affinityScore": "1"
    },
    {
        "career_code": "19405100",
        "cipt_code": "410204",
        "affinityScore": "1"
    },
    {
        "career_code": "19405100",
        "cipt_code": "410205",
        "affinityScore": "1"
    },
    {
        "career_code": "51801100",
        "cipt_code": "410205",
        "affinityScore": "1"
    },
    {
        "career_code": "19405100",
        "cipt_code": "410299",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "410301",
        "affinityScore": "1"
    },
    {
        "career_code": "51809100",
        "cipt_code": "410301",
        "affinityScore": "1"
    },
    {
        "career_code": "51901100",
        "cipt_code": "410301",
        "affinityScore": "1"
    },
    {
        "career_code": "19403100",
        "cipt_code": "410303",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "410303",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "410303",
        "affinityScore": "1"
    },
    {
        "career_code": "51809100",
        "cipt_code": "410303",
        "affinityScore": "1"
    },
    {
        "career_code": "51901100",
        "cipt_code": "410303",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "410399",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "410399",
        "affinityScore": "1"
    },
    {
        "career_code": "19404400",
        "cipt_code": "410399",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "410399",
        "affinityScore": "1"
    },
    {
        "career_code": "19404200",
        "cipt_code": "419999",
        "affinityScore": "1"
    },
    {
        "career_code": "19404300",
        "cipt_code": "419999",
        "affinityScore": "1"
    },
    {
        "career_code": "19404400",
        "cipt_code": "419999",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "419999",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "420101",
        "affinityScore": "1"
    },
    {
        "career_code": "19303200",
        "cipt_code": "420101",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "420101",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "420101",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "420101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "420101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422701",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422701",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422701",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422702",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422702",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422702",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422703",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422703",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "422703",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422703",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422704",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422704",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422704",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422705",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422705",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422705",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422706",
        "affinityScore": "1"
    },
    {
        "career_code": "19102900",
        "cipt_code": "422706",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "422706",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422706",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422706",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422707",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422707",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422707",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422708",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "422708",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422708",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "422708",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422708",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422709",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "422709",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422709",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "422709",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422710",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "422710",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422710",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422799",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422799",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422799",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422801",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422801",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422801",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422802",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422802",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422802",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422803",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422803",
        "affinityScore": "1"
    },
    {
        "career_code": "21101400",
        "cipt_code": "422803",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "422803",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422803",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "13107100",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "19303200",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422804",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422805",
        "affinityScore": "1"
    },
    {
        "career_code": "19303400",
        "cipt_code": "422805",
        "affinityScore": "1"
    },
    {
        "career_code": "21101200",
        "cipt_code": "422805",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422805",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422806",
        "affinityScore": "1"
    },
    {
        "career_code": "19303400",
        "cipt_code": "422806",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422806",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422806",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422807",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422807",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422807",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422807",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422808",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422808",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422808",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422809",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422809",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422809",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422810",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422810",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422810",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422810",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422811",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422811",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422811",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422811",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422812",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422812",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422812",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422813",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422813",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422813",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422814",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "422814",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422814",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422814",
        "affinityScore": "1"
    },
    {
        "career_code": "25904300",
        "cipt_code": "422814",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422815",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422815",
        "affinityScore": "1"
    },
    {
        "career_code": "27202200",
        "cipt_code": "422815",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422816",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422816",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422817",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422817",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "422899",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "422899",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "422899",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "429999",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "429999",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "429999",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "33101100",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "33301200",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430100",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430102",
        "affinityScore": "1"
    },
    {
        "career_code": "33101100",
        "cipt_code": "430102",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430102",
        "affinityScore": "1"
    },
    {
        "career_code": "33301200",
        "cipt_code": "430102",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430103",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430103",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430103",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "430104",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430104",
        "affinityScore": "1"
    },
    {
        "career_code": "33101100",
        "cipt_code": "430104",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430104",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430107",
        "affinityScore": "1"
    },
    {
        "career_code": "33301100",
        "cipt_code": "430107",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430107",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430107",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430107",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430109",
        "affinityScore": "1"
    },
    {
        "career_code": "33109100",
        "cipt_code": "430109",
        "affinityScore": "1"
    },
    {
        "career_code": "33305200",
        "cipt_code": "430109",
        "affinityScore": "1"
    },
    {
        "career_code": "33903100",
        "cipt_code": "430109",
        "affinityScore": "1"
    },
    {
        "career_code": "33903200",
        "cipt_code": "430109",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "430110",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430110",
        "affinityScore": "1"
    },
    {
        "career_code": "33301200",
        "cipt_code": "430110",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430112",
        "affinityScore": "1"
    },
    {
        "career_code": "33109100",
        "cipt_code": "430112",
        "affinityScore": "1"
    },
    {
        "career_code": "33109900",
        "cipt_code": "430112",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430113",
        "affinityScore": "1"
    },
    {
        "career_code": "33101100",
        "cipt_code": "430113",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430114",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430114",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430114",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430115",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430115",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430115",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430115",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430115",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430115",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "430119",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430119",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430119",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430119",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "430120",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430120",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430120",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430120",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430120",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "430121",
        "affinityScore": "1"
    },
    {
        "career_code": "13206100",
        "cipt_code": "430121",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430121",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430121",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430122",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430122",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430122",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430122",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430122",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430123",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430123",
        "affinityScore": "1"
    },
    {
        "career_code": "33109900",
        "cipt_code": "430123",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430123",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430123",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430199",
        "affinityScore": "1"
    },
    {
        "career_code": "33301200",
        "cipt_code": "430199",
        "affinityScore": "1"
    },
    {
        "career_code": "33102100",
        "cipt_code": "430201",
        "affinityScore": "1"
    },
    {
        "career_code": "33201100",
        "cipt_code": "430201",
        "affinityScore": "1"
    },
    {
        "career_code": "33202100",
        "cipt_code": "430201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430202",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "430202",
        "affinityScore": "1"
    },
    {
        "career_code": "33102100",
        "cipt_code": "430202",
        "affinityScore": "1"
    },
    {
        "career_code": "33102100",
        "cipt_code": "430203",
        "affinityScore": "1"
    },
    {
        "career_code": "33201100",
        "cipt_code": "430203",
        "affinityScore": "1"
    },
    {
        "career_code": "33202100",
        "cipt_code": "430203",
        "affinityScore": "1"
    },
    {
        "career_code": "33202200",
        "cipt_code": "430203",
        "affinityScore": "1"
    },
    {
        "career_code": "33102100",
        "cipt_code": "430205",
        "affinityScore": "1"
    },
    {
        "career_code": "33202100",
        "cipt_code": "430205",
        "affinityScore": "1"
    },
    {
        "career_code": "33201100",
        "cipt_code": "430206",
        "affinityScore": "1"
    },
    {
        "career_code": "33202200",
        "cipt_code": "430206",
        "affinityScore": "1"
    },
    {
        "career_code": "33102100",
        "cipt_code": "430299",
        "affinityScore": "1"
    },
    {
        "career_code": "33201100",
        "cipt_code": "430299",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "430301",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430301",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430301",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "430302",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430302",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430302",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "430303",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430303",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430303",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "430304",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430399",
        "affinityScore": "1"
    },
    {
        "career_code": "33109100",
        "cipt_code": "430399",
        "affinityScore": "1"
    },
    {
        "career_code": "33109900",
        "cipt_code": "430399",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430401",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430401",
        "affinityScore": "1"
    },
    {
        "career_code": "33109100",
        "cipt_code": "430401",
        "affinityScore": "1"
    },
    {
        "career_code": "33109900",
        "cipt_code": "430401",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "430402",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "430402",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430402",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430402",
        "affinityScore": "1"
    },
    {
        "career_code": "33305100",
        "cipt_code": "430402",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "430403",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "430403",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430403",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430403",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430403",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "430404",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430404",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430404",
        "affinityScore": "1"
    },
    {
        "career_code": "33109900",
        "cipt_code": "430404",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "430404",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "430404",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "430405",
        "affinityScore": "1"
    },
    {
        "career_code": "13206100",
        "cipt_code": "430405",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430405",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430405",
        "affinityScore": "1"
    },
    {
        "career_code": "33902100",
        "cipt_code": "430405",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "430406",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "430406",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430406",
        "affinityScore": "1"
    },
    {
        "career_code": "17102100",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "55101700",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "55301800",
        "cipt_code": "430407",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430408",
        "affinityScore": "1"
    },
    {
        "career_code": "33302100",
        "cipt_code": "430408",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "430499",
        "affinityScore": "1"
    },
    {
        "career_code": "33101200",
        "cipt_code": "430499",
        "affinityScore": "1"
    },
    {
        "career_code": "33109100",
        "cipt_code": "430499",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440000",
        "affinityScore": "1"
    },
    {
        "career_code": "21109300",
        "cipt_code": "440000",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "440000",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440201",
        "affinityScore": "1"
    },
    {
        "career_code": "21109900",
        "cipt_code": "440201",
        "affinityScore": "1"
    },
    {
        "career_code": "43406100",
        "cipt_code": "440201",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11103100",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11913100",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "440401",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "440402",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "440402",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "440403",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "440403",
        "affinityScore": "1"
    },
    {
        "career_code": "53604100",
        "cipt_code": "440403",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "440499",
        "affinityScore": "1"
    },
    {
        "career_code": "11103100",
        "cipt_code": "440501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "440501",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "440501",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "440501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "440502",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "440502",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "440502",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "440502",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "440503",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "440503",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "440503",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "440503",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "440504",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "440504",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "440504",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21101300",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21102300",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21102900",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "21109200",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "25111300",
        "cipt_code": "440701",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440702",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "440702",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440703",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "440703",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "440703",
        "affinityScore": "1"
    },
    {
        "career_code": "21102900",
        "cipt_code": "440703",
        "affinityScore": "1"
    },
    {
        "career_code": "25111300",
        "cipt_code": "440703",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "440799",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "440799",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "440799",
        "affinityScore": "1"
    },
    {
        "career_code": "21102300",
        "cipt_code": "440799",
        "affinityScore": "1"
    },
    {
        "career_code": "21102900",
        "cipt_code": "440799",
        "affinityScore": "1"
    },
    {
        "career_code": "25111300",
        "cipt_code": "440799",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450101",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "450101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "450101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "450101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450102",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "450102",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "450102",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "450102",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450102",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "450102",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "450103",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450199",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450199",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "450199",
        "affinityScore": "1"
    },
    {
        "career_code": "25202100",
        "cipt_code": "450199",
        "affinityScore": "1"
    },
    {
        "career_code": "25202200",
        "cipt_code": "450199",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "450199",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450201",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450202",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450202",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450202",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450203",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450203",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450203",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450204",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450204",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450204",
        "affinityScore": "1"
    },
    {
        "career_code": "25106200",
        "cipt_code": "450204",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450205",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "450205",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450205",
        "affinityScore": "1"
    },
    {
        "career_code": "19409200",
        "cipt_code": "450205",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450205",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450299",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450299",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450299",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450301",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "450301",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "450301",
        "affinityScore": "1"
    },
    {
        "career_code": "39701100",
        "cipt_code": "450301",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450401",
        "affinityScore": "1"
    },
    {
        "career_code": "19303900",
        "cipt_code": "450401",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "450401",
        "affinityScore": "1"
    },
    {
        "career_code": "19409900",
        "cipt_code": "450401",
        "affinityScore": "1"
    },
    {
        "career_code": "25111100",
        "cipt_code": "450401",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450501",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "450501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450501",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "450501",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450502",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "450502",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450502",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "450502",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450599",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "450599",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "450599",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "450599",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450601",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "450601",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "450601",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "450601",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "450601",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "450601",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450602",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "450602",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "450602",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "450602",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "450602",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "450602",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450603",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "450603",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "450603",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "450603",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "450603",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "450603",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450604",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "450604",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "450604",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "450604",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450605",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "450605",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "450605",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450699",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "450699",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "450699",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450701",
        "affinityScore": "1"
    },
    {
        "career_code": "17303100",
        "cipt_code": "450701",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "450701",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "450701",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450702",
        "affinityScore": "1"
    },
    {
        "career_code": "17102100",
        "cipt_code": "450702",
        "affinityScore": "1"
    },
    {
        "career_code": "17303100",
        "cipt_code": "450702",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "450702",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "450702",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450799",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "450799",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "450799",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450901",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "450901",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "450901",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450902",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "450902",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "450902",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "450999",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "450999",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "450999",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451001",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "451001",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "451001",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "451001",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "451001",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451002",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "451002",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "451002",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "451002",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451003",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "451003",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "451003",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451004",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "451004",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "451004",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "451004",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "451004",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "451004",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451099",
        "affinityScore": "1"
    },
    {
        "career_code": "19309400",
        "cipt_code": "451099",
        "affinityScore": "1"
    },
    {
        "career_code": "25106500",
        "cipt_code": "451099",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "451099",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451101",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "451101",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "451101",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "451101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451102",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "451102",
        "affinityScore": "1"
    },
    {
        "career_code": "19406100",
        "cipt_code": "451102",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "451102",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451103",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "451103",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "451103",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "451103",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451199",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "451199",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "451199",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "451199",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451201",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "451201",
        "affinityScore": "1"
    },
    {
        "career_code": "19305100",
        "cipt_code": "451201",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "451201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451301",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "451301",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "451301",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "451301",
        "affinityScore": "1"
    },
    {
        "career_code": "25106700",
        "cipt_code": "451301",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "451501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "451501",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "451501",
        "affinityScore": "1"
    },
    {
        "career_code": "25106100",
        "cipt_code": "451501",
        "affinityScore": "1"
    },
    {
        "career_code": "25106400",
        "cipt_code": "451501",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "459999",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "459999",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "459999",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460000",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460101",
        "affinityScore": "1"
    },
    {
        "career_code": "47202100",
        "cipt_code": "460101",
        "affinityScore": "1"
    },
    {
        "career_code": "47202200",
        "cipt_code": "460101",
        "affinityScore": "1"
    },
    {
        "career_code": "47204400",
        "cipt_code": "460101",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460201",
        "affinityScore": "1"
    },
    {
        "career_code": "47203100",
        "cipt_code": "460201",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "460301",
        "affinityScore": "1"
    },
    {
        "career_code": "49209500",
        "cipt_code": "460301",
        "affinityScore": "1"
    },
    {
        "career_code": "49905100",
        "cipt_code": "460301",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460302",
        "affinityScore": "1"
    },
    {
        "career_code": "47211100",
        "cipt_code": "460302",
        "affinityScore": "1"
    },
    {
        "career_code": "49209800",
        "cipt_code": "460302",
        "affinityScore": "1"
    },
    {
        "career_code": "49909700",
        "cipt_code": "460302",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "460303",
        "affinityScore": "1"
    },
    {
        "career_code": "49905100",
        "cipt_code": "460303",
        "affinityScore": "1"
    },
    {
        "career_code": "49905100",
        "cipt_code": "460399",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "460401",
        "affinityScore": "1"
    },
    {
        "career_code": "37101100",
        "cipt_code": "460401",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460401",
        "affinityScore": "1"
    },
    {
        "career_code": "49907100",
        "cipt_code": "460401",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460402",
        "affinityScore": "1"
    },
    {
        "career_code": "47205100",
        "cipt_code": "460402",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460403",
        "affinityScore": "1"
    },
    {
        "career_code": "47401100",
        "cipt_code": "460403",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460404",
        "affinityScore": "1"
    },
    {
        "career_code": "47208100",
        "cipt_code": "460404",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460406",
        "affinityScore": "1"
    },
    {
        "career_code": "47212100",
        "cipt_code": "460406",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460408",
        "affinityScore": "1"
    },
    {
        "career_code": "47214100",
        "cipt_code": "460408",
        "affinityScore": "1"
    },
    {
        "career_code": "47214200",
        "cipt_code": "460408",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460410",
        "affinityScore": "1"
    },
    {
        "career_code": "47218100",
        "cipt_code": "460410",
        "affinityScore": "1"
    },
    {
        "career_code": "47223100",
        "cipt_code": "460410",
        "affinityScore": "1"
    },
    {
        "career_code": "47222100",
        "cipt_code": "460411",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "460412",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460412",
        "affinityScore": "1"
    },
    {
        "career_code": "49909500",
        "cipt_code": "460412",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460413",
        "affinityScore": "1"
    },
    {
        "career_code": "47204100",
        "cipt_code": "460413",
        "affinityScore": "1"
    },
    {
        "career_code": "47204200",
        "cipt_code": "460413",
        "affinityScore": "1"
    },
    {
        "career_code": "47204300",
        "cipt_code": "460413",
        "affinityScore": "1"
    },
    {
        "career_code": "47204400",
        "cipt_code": "460413",
        "affinityScore": "1"
    },
    {
        "career_code": "47205300",
        "cipt_code": "460413",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460414",
        "affinityScore": "1"
    },
    {
        "career_code": "47213100",
        "cipt_code": "460414",
        "affinityScore": "1"
    },
    {
        "career_code": "47213200",
        "cipt_code": "460414",
        "affinityScore": "1"
    },
    {
        "career_code": "17302200",
        "cipt_code": "460415",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460415",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460502",
        "affinityScore": "1"
    },
    {
        "career_code": "47215200",
        "cipt_code": "460502",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460503",
        "affinityScore": "1"
    },
    {
        "career_code": "47215200",
        "cipt_code": "460503",
        "affinityScore": "1"
    },
    {
        "career_code": "47407100",
        "cipt_code": "460503",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460504",
        "affinityScore": "1"
    },
    {
        "career_code": "47501100",
        "cipt_code": "460504",
        "affinityScore": "1"
    },
    {
        "career_code": "47501200",
        "cipt_code": "460504",
        "affinityScore": "1"
    },
    {
        "career_code": "47502300",
        "cipt_code": "460504",
        "affinityScore": "1"
    },
    {
        "career_code": "47503200",
        "cipt_code": "460504",
        "affinityScore": "1"
    },
    {
        "career_code": "47101100",
        "cipt_code": "460505",
        "affinityScore": "1"
    },
    {
        "career_code": "47503200",
        "cipt_code": "460505",
        "affinityScore": "1"
    },
    {
        "career_code": "47215200",
        "cipt_code": "460599",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470000",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470000",
        "affinityScore": "1"
    },
    {
        "career_code": "49209200",
        "cipt_code": "470101",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470101",
        "affinityScore": "1"
    },
    {
        "career_code": "49201100",
        "cipt_code": "470102",
        "affinityScore": "1"
    },
    {
        "career_code": "43209900",
        "cipt_code": "470103",
        "affinityScore": "1"
    },
    {
        "career_code": "49202100",
        "cipt_code": "470103",
        "affinityScore": "1"
    },
    {
        "career_code": "49202200",
        "cipt_code": "470103",
        "affinityScore": "1"
    },
    {
        "career_code": "49209700",
        "cipt_code": "470103",
        "affinityScore": "1"
    },
    {
        "career_code": "49905200",
        "cipt_code": "470103",
        "affinityScore": "1"
    },
    {
        "career_code": "49201100",
        "cipt_code": "470104",
        "affinityScore": "1"
    },
    {
        "career_code": "49209400",
        "cipt_code": "470104",
        "affinityScore": "1"
    },
    {
        "career_code": "49209400",
        "cipt_code": "470105",
        "affinityScore": "1"
    },
    {
        "career_code": "51914100",
        "cipt_code": "470105",
        "affinityScore": "1"
    },
    {
        "career_code": "49903100",
        "cipt_code": "470106",
        "affinityScore": "1"
    },
    {
        "career_code": "49209800",
        "cipt_code": "470110",
        "affinityScore": "1"
    },
    {
        "career_code": "49209500",
        "cipt_code": "470199",
        "affinityScore": "1"
    },
    {
        "career_code": "49902100",
        "cipt_code": "470201",
        "affinityScore": "1"
    },
    {
        "career_code": "49304200",
        "cipt_code": "470302",
        "affinityScore": "1"
    },
    {
        "career_code": "49304300",
        "cipt_code": "470302",
        "affinityScore": "1"
    },
    {
        "career_code": "49901200",
        "cipt_code": "470302",
        "affinityScore": "1"
    },
    {
        "career_code": "47402100",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49901200",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49904100",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49904300",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49904400",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49904500",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49908100",
        "cipt_code": "470303",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470402",
        "affinityScore": "1"
    },
    {
        "career_code": "49909400",
        "cipt_code": "470403",
        "affinityScore": "1"
    },
    {
        "career_code": "49906300",
        "cipt_code": "470404",
        "affinityScore": "1"
    },
    {
        "career_code": "49906400",
        "cipt_code": "470408",
        "affinityScore": "1"
    },
    {
        "career_code": "51206100",
        "cipt_code": "470408",
        "affinityScore": "1"
    },
    {
        "career_code": "51907100",
        "cipt_code": "470408",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470409",
        "affinityScore": "1"
    },
    {
        "career_code": "49906100",
        "cipt_code": "470499",
        "affinityScore": "1"
    },
    {
        "career_code": "49906900",
        "cipt_code": "470499",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470600",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "470600",
        "affinityScore": "1"
    },
    {
        "career_code": "13103200",
        "cipt_code": "470603",
        "affinityScore": "1"
    },
    {
        "career_code": "49302100",
        "cipt_code": "470603",
        "affinityScore": "1"
    },
    {
        "career_code": "49302200",
        "cipt_code": "470603",
        "affinityScore": "1"
    },
    {
        "career_code": "51912400",
        "cipt_code": "470603",
        "affinityScore": "1"
    },
    {
        "career_code": "49209300",
        "cipt_code": "470604",
        "affinityScore": "1"
    },
    {
        "career_code": "49209600",
        "cipt_code": "470604",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "470604",
        "affinityScore": "1"
    },
    {
        "career_code": "49303100",
        "cipt_code": "470605",
        "affinityScore": "1"
    },
    {
        "career_code": "49305100",
        "cipt_code": "470606",
        "affinityScore": "1"
    },
    {
        "career_code": "49305300",
        "cipt_code": "470606",
        "affinityScore": "1"
    },
    {
        "career_code": "49301100",
        "cipt_code": "470607",
        "affinityScore": "1"
    },
    {
        "career_code": "51201100",
        "cipt_code": "470607",
        "affinityScore": "1"
    },
    {
        "career_code": "49301100",
        "cipt_code": "470608",
        "affinityScore": "1"
    },
    {
        "career_code": "51201100",
        "cipt_code": "470608",
        "affinityScore": "1"
    },
    {
        "career_code": "17302100",
        "cipt_code": "470609",
        "affinityScore": "1"
    },
    {
        "career_code": "49209100",
        "cipt_code": "470609",
        "affinityScore": "1"
    },
    {
        "career_code": "51201100",
        "cipt_code": "470609",
        "affinityScore": "1"
    },
    {
        "career_code": "49309100",
        "cipt_code": "470610",
        "affinityScore": "1"
    },
    {
        "career_code": "49305200",
        "cipt_code": "470611",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "470612",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "470613",
        "affinityScore": "1"
    },
    {
        "career_code": "49303100",
        "cipt_code": "470613",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "470614",
        "affinityScore": "1"
    },
    {
        "career_code": "51203100",
        "cipt_code": "470615",
        "affinityScore": "1"
    },
    {
        "career_code": "49305100",
        "cipt_code": "470616",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470617",
        "affinityScore": "1"
    },
    {
        "career_code": "49302300",
        "cipt_code": "470617",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470618",
        "affinityScore": "1"
    },
    {
        "career_code": "49309200",
        "cipt_code": "470618",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470701",
        "affinityScore": "1"
    },
    {
        "career_code": "49904100",
        "cipt_code": "470701",
        "affinityScore": "1"
    },
    {
        "career_code": "49908100",
        "cipt_code": "470701",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470701",
        "affinityScore": "1"
    },
    {
        "career_code": "47223100",
        "cipt_code": "470703",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470703",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470703",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470704",
        "affinityScore": "1"
    },
    {
        "career_code": "49908100",
        "cipt_code": "470704",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470705",
        "affinityScore": "1"
    },
    {
        "career_code": "49904100",
        "cipt_code": "470705",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470705",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "470706",
        "affinityScore": "1"
    },
    {
        "career_code": "49904100",
        "cipt_code": "470706",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470706",
        "affinityScore": "1"
    },
    {
        "career_code": "49909900",
        "cipt_code": "470799",
        "affinityScore": "1"
    },
    {
        "career_code": "51609300",
        "cipt_code": "480303",
        "affinityScore": "1"
    },
    {
        "career_code": "51604100",
        "cipt_code": "480304",
        "affinityScore": "1"
    },
    {
        "career_code": "51604200",
        "cipt_code": "480304",
        "affinityScore": "1"
    },
    {
        "career_code": "51402100",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51402200",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51402300",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51403100",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51403200",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51403300",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51403400",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51403500",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51404100",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51408100",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51419100",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51419200",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51419900",
        "cipt_code": "480501",
        "affinityScore": "1"
    },
    {
        "career_code": "51204100",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51403300",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51404100",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51408100",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51419100",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51419200",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51419400",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51419900",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "51916100",
        "cipt_code": "480503",
        "affinityScore": "1"
    },
    {
        "career_code": "47221100",
        "cipt_code": "480506",
        "affinityScore": "1"
    },
    {
        "career_code": "51402300",
        "cipt_code": "480506",
        "affinityScore": "1"
    },
    {
        "career_code": "51403100",
        "cipt_code": "480506",
        "affinityScore": "1"
    },
    {
        "career_code": "51406100",
        "cipt_code": "480506",
        "affinityScore": "1"
    },
    {
        "career_code": "51406200",
        "cipt_code": "480506",
        "affinityScore": "1"
    },
    {
        "career_code": "51411100",
        "cipt_code": "480507",
        "affinityScore": "1"
    },
    {
        "career_code": "51412100",
        "cipt_code": "480508",
        "affinityScore": "1"
    },
    {
        "career_code": "51412200",
        "cipt_code": "480508",
        "affinityScore": "1"
    },
    {
        "career_code": "51407100",
        "cipt_code": "480509",
        "affinityScore": "1"
    },
    {
        "career_code": "51916100",
        "cipt_code": "480510",
        "affinityScore": "1"
    },
    {
        "career_code": "51916200",
        "cipt_code": "480510",
        "affinityScore": "1"
    },
    {
        "career_code": "51204100",
        "cipt_code": "480511",
        "affinityScore": "1"
    },
    {
        "career_code": "51419900",
        "cipt_code": "480599",
        "affinityScore": "1"
    },
    {
        "career_code": "51704200",
        "cipt_code": "480701",
        "affinityScore": "1"
    },
    {
        "career_code": "51709900",
        "cipt_code": "480701",
        "affinityScore": "1"
    },
    {
        "career_code": "51702100",
        "cipt_code": "480702",
        "affinityScore": "1"
    },
    {
        "career_code": "51709900",
        "cipt_code": "480702",
        "affinityScore": "1"
    },
    {
        "career_code": "51701100",
        "cipt_code": "480703",
        "affinityScore": "1"
    },
    {
        "career_code": "51703100",
        "cipt_code": "480703",
        "affinityScore": "1"
    },
    {
        "career_code": "51703200",
        "cipt_code": "480703",
        "affinityScore": "1"
    },
    {
        "career_code": "51704100",
        "cipt_code": "480703",
        "affinityScore": "1"
    },
    {
        "career_code": "51704200",
        "cipt_code": "480703",
        "affinityScore": "1"
    },
    {
        "career_code": "51709900",
        "cipt_code": "480703",
        "affinityScore": "1"
    },
    {
        "career_code": "51703100",
        "cipt_code": "480704",
        "affinityScore": "1"
    },
    {
        "career_code": "51709900",
        "cipt_code": "480704",
        "affinityScore": "1"
    },
    {
        "career_code": "51709900",
        "cipt_code": "480799",
        "affinityScore": "1"
    },
    {
        "career_code": "47201100",
        "cipt_code": "480801",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "490101",
        "affinityScore": "1"
    },
    {
        "career_code": "53201100",
        "cipt_code": "490102",
        "affinityScore": "1"
    },
    {
        "career_code": "53201200",
        "cipt_code": "490102",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "490104",
        "affinityScore": "1"
    },
    {
        "career_code": "53202100",
        "cipt_code": "490105",
        "affinityScore": "1"
    },
    {
        "career_code": "53202200",
        "cipt_code": "490105",
        "affinityScore": "1"
    },
    {
        "career_code": "53104400",
        "cipt_code": "490106",
        "affinityScore": "1"
    },
    {
        "career_code": "53203100",
        "cipt_code": "490106",
        "affinityScore": "1"
    },
    {
        "career_code": "53201100",
        "cipt_code": "490108",
        "affinityScore": "1"
    },
    {
        "career_code": "53201200",
        "cipt_code": "490108",
        "affinityScore": "1"
    },
    {
        "career_code": "45402200",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47207100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47207200",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47207300",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47405100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47406100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47502200",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47502300",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47503200",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47504100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47504900",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "47509900",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "53702100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "53703100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "53704100",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "53719900",
        "cipt_code": "490202",
        "affinityScore": "1"
    },
    {
        "career_code": "25119400",
        "cipt_code": "490205",
        "affinityScore": "1"
    },
    {
        "career_code": "53303200",
        "cipt_code": "490205",
        "affinityScore": "1"
    },
    {
        "career_code": "53303300",
        "cipt_code": "490205",
        "affinityScore": "1"
    },
    {
        "career_code": "53305100",
        "cipt_code": "490205",
        "affinityScore": "1"
    },
    {
        "career_code": "53305200",
        "cipt_code": "490205",
        "affinityScore": "1"
    },
    {
        "career_code": "53305300",
        "cipt_code": "490205",
        "affinityScore": "1"
    },
    {
        "career_code": "47207300",
        "cipt_code": "490206",
        "affinityScore": "1"
    },
    {
        "career_code": "53702100",
        "cipt_code": "490206",
        "affinityScore": "1"
    },
    {
        "career_code": "47405100",
        "cipt_code": "490207",
        "affinityScore": "1"
    },
    {
        "career_code": "53104300",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53104900",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53401100",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53401300",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53402200",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53403100",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53404100",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53409900",
        "cipt_code": "490208",
        "affinityScore": "1"
    },
    {
        "career_code": "53705100",
        "cipt_code": "490209",
        "affinityScore": "1"
    },
    {
        "career_code": "53502100",
        "cipt_code": "490303",
        "affinityScore": "1"
    },
    {
        "career_code": "49909200",
        "cipt_code": "490304",
        "affinityScore": "1"
    },
    {
        "career_code": "53502100",
        "cipt_code": "490309",
        "affinityScore": "1"
    },
    {
        "career_code": "53502200",
        "cipt_code": "490309",
        "affinityScore": "1"
    },
    {
        "career_code": "53503100",
        "cipt_code": "490309",
        "affinityScore": "1"
    },
    {
        "career_code": "53502200",
        "cipt_code": "490399",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500101",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500101",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500101",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500101",
        "affinityScore": "1"
    },
    {
        "career_code": "27402100",
        "cipt_code": "500101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500102",
        "affinityScore": "1"
    },
    {
        "career_code": "27101100",
        "cipt_code": "500102",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "500102",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500102",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "500102",
        "affinityScore": "1"
    },
    {
        "career_code": "27402100",
        "cipt_code": "500102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500201",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500201",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500301",
        "affinityScore": "1"
    },
    {
        "career_code": "27203100",
        "cipt_code": "500301",
        "affinityScore": "1"
    },
    {
        "career_code": "27203200",
        "cipt_code": "500301",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500302",
        "affinityScore": "1"
    },
    {
        "career_code": "27203100",
        "cipt_code": "500302",
        "affinityScore": "1"
    },
    {
        "career_code": "27203200",
        "cipt_code": "500302",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500399",
        "affinityScore": "1"
    },
    {
        "career_code": "27203100",
        "cipt_code": "500399",
        "affinityScore": "1"
    },
    {
        "career_code": "27203200",
        "cipt_code": "500399",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "500401",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500401",
        "affinityScore": "1"
    },
    {
        "career_code": "27102100",
        "cipt_code": "500401",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "500401",
        "affinityScore": "1"
    },
    {
        "career_code": "27102700",
        "cipt_code": "500401",
        "affinityScore": "1"
    },
    {
        "career_code": "27102900",
        "cipt_code": "500401",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500402",
        "affinityScore": "1"
    },
    {
        "career_code": "27102100",
        "cipt_code": "500402",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "500402",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500404",
        "affinityScore": "1"
    },
    {
        "career_code": "27102100",
        "cipt_code": "500404",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "500404",
        "affinityScore": "1"
    },
    {
        "career_code": "27102900",
        "cipt_code": "500404",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500406",
        "affinityScore": "1"
    },
    {
        "career_code": "27402100",
        "cipt_code": "500406",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500407",
        "affinityScore": "1"
    },
    {
        "career_code": "27102200",
        "cipt_code": "500407",
        "affinityScore": "1"
    },
    {
        "career_code": "25103100",
        "cipt_code": "500408",
        "affinityScore": "1"
    },
    {
        "career_code": "27102500",
        "cipt_code": "500408",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "500409",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500409",
        "affinityScore": "1"
    },
    {
        "career_code": "27101100",
        "cipt_code": "500409",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "500409",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500409",
        "affinityScore": "1"
    },
    {
        "career_code": "27102400",
        "cipt_code": "500409",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500410",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500410",
        "affinityScore": "1"
    },
    {
        "career_code": "27102700",
        "cipt_code": "500410",
        "affinityScore": "1"
    },
    {
        "career_code": "27102900",
        "cipt_code": "500410",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "500411",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "500411",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500501",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500501",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500501",
        "affinityScore": "1"
    },
    {
        "career_code": "27209900",
        "cipt_code": "500501",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500502",
        "affinityScore": "1"
    },
    {
        "career_code": "27102700",
        "cipt_code": "500502",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500504",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "500504",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500505",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500506",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500506",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500507",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500507",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500507",
        "affinityScore": "1"
    },
    {
        "career_code": "27209900",
        "cipt_code": "500507",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "27203100",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "27203200",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500509",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500510",
        "affinityScore": "1"
    },
    {
        "career_code": "27102200",
        "cipt_code": "500510",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500511",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500511",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "500511",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500512",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500512",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500512",
        "affinityScore": "1"
    },
    {
        "career_code": "27203100",
        "cipt_code": "500512",
        "affinityScore": "1"
    },
    {
        "career_code": "27203200",
        "cipt_code": "500512",
        "affinityScore": "1"
    },
    {
        "career_code": "27209900",
        "cipt_code": "500512",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500599",
        "affinityScore": "1"
    },
    {
        "career_code": "27201100",
        "cipt_code": "500599",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500599",
        "affinityScore": "1"
    },
    {
        "career_code": "27209900",
        "cipt_code": "500599",
        "affinityScore": "1"
    },
    {
        "career_code": "39309200",
        "cipt_code": "500599",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500601",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500601",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500602",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500602",
        "affinityScore": "1"
    },
    {
        "career_code": "27403100",
        "cipt_code": "500602",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "500602",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500605",
        "affinityScore": "1"
    },
    {
        "career_code": "27402100",
        "cipt_code": "500605",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500607",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "500607",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "500607",
        "affinityScore": "1"
    },
    {
        "career_code": "27403100",
        "cipt_code": "500607",
        "affinityScore": "1"
    },
    {
        "career_code": "27403200",
        "cipt_code": "500607",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500699",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500701",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "500701",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500701",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500701",
        "affinityScore": "1"
    },
    {
        "career_code": "27402100",
        "cipt_code": "500701",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500702",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500702",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500702",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "500703",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500703",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "500703",
        "affinityScore": "1"
    },
    {
        "career_code": "25401200",
        "cipt_code": "500703",
        "affinityScore": "1"
    },
    {
        "career_code": "25401300",
        "cipt_code": "500703",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500705",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500705",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500705",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "500705",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500706",
        "affinityScore": "1"
    },
    {
        "career_code": "27101100",
        "cipt_code": "500706",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500706",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "500706",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500708",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500708",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500708",
        "affinityScore": "1"
    },
    {
        "career_code": "27101400",
        "cipt_code": "500708",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500709",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500709",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500709",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500710",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500710",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500710",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500711",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500711",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500711",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500712",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500712",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500713",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500713",
        "affinityScore": "1"
    },
    {
        "career_code": "51907100",
        "cipt_code": "500713",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500714",
        "affinityScore": "1"
    },
    {
        "career_code": "27101200",
        "cipt_code": "500714",
        "affinityScore": "1"
    },
    {
        "career_code": "51907100",
        "cipt_code": "500714",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500799",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "500799",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "500799",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "500901",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500901",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500902",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500903",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500903",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500903",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500904",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500904",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500905",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500905",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500906",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500906",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500907",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500907",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500908",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500908",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500908",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500910",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500910",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500911",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500911",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500912",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500912",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500913",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500913",
        "affinityScore": "1"
    },
    {
        "career_code": "27209100",
        "cipt_code": "500913",
        "affinityScore": "1"
    },
    {
        "career_code": "27401400",
        "cipt_code": "500913",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500914",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500914",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500915",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500915",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500916",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500916",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500917",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500917",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "500999",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "500999",
        "affinityScore": "1"
    },
    {
        "career_code": "27204200",
        "cipt_code": "500999",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "501001",
        "affinityScore": "1"
    },
    {
        "career_code": "13101100",
        "cipt_code": "501001",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "501001",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "501002",
        "affinityScore": "1"
    },
    {
        "career_code": "13101100",
        "cipt_code": "501002",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "501002",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "501003",
        "affinityScore": "1"
    },
    {
        "career_code": "27204100",
        "cipt_code": "501003",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "501004",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "501004",
        "affinityScore": "1"
    },
    {
        "career_code": "27201200",
        "cipt_code": "501004",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "501099",
        "affinityScore": "1"
    },
    {
        "career_code": "13101100",
        "cipt_code": "501099",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "501099",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "501101",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "501101",
        "affinityScore": "1"
    },
    {
        "career_code": "27101900",
        "cipt_code": "501101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112100",
        "cipt_code": "509999",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "510001",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "510001",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510101",
        "affinityScore": "1"
    },
    {
        "career_code": "29101100",
        "cipt_code": "510101",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510201",
        "affinityScore": "1"
    },
    {
        "career_code": "29112700",
        "cipt_code": "510201",
        "affinityScore": "1"
    },
    {
        "career_code": "29118100",
        "cipt_code": "510201",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510202",
        "affinityScore": "1"
    },
    {
        "career_code": "29118100",
        "cipt_code": "510202",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510203",
        "affinityScore": "1"
    },
    {
        "career_code": "29112700",
        "cipt_code": "510203",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510204",
        "affinityScore": "1"
    },
    {
        "career_code": "29112700",
        "cipt_code": "510204",
        "affinityScore": "1"
    },
    {
        "career_code": "29118100",
        "cipt_code": "510204",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510299",
        "affinityScore": "1"
    },
    {
        "career_code": "29112700",
        "cipt_code": "510299",
        "affinityScore": "1"
    },
    {
        "career_code": "29118100",
        "cipt_code": "510299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510401",
        "affinityScore": "1"
    },
    {
        "career_code": "29102100",
        "cipt_code": "510401",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510501",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510501",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510502",
        "affinityScore": "1"
    },
    {
        "career_code": "29102100",
        "cipt_code": "510502",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510503",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "510504",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510504",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510504",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510505",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510505",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510506",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510506",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510507",
        "affinityScore": "1"
    },
    {
        "career_code": "29102200",
        "cipt_code": "510507",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510508",
        "affinityScore": "1"
    },
    {
        "career_code": "29102300",
        "cipt_code": "510508",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510509",
        "affinityScore": "1"
    },
    {
        "career_code": "29102100",
        "cipt_code": "510509",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510510",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510510",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510511",
        "affinityScore": "1"
    },
    {
        "career_code": "29102400",
        "cipt_code": "510511",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510512",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510512",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510513",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510513",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510514",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510514",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510599",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "510599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510601",
        "affinityScore": "1"
    },
    {
        "career_code": "31909100",
        "cipt_code": "510601",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510602",
        "affinityScore": "1"
    },
    {
        "career_code": "29129200",
        "cipt_code": "510602",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510603",
        "affinityScore": "1"
    },
    {
        "career_code": "51908100",
        "cipt_code": "510603",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510701",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "510702",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510702",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "510702",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510703",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510704",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "510705",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510706",
        "affinityScore": "1"
    },
    {
        "career_code": "29207200",
        "cipt_code": "510706",
        "affinityScore": "1"
    },
    {
        "career_code": "29902100",
        "cipt_code": "510706",
        "affinityScore": "1"
    },
    {
        "career_code": "29207200",
        "cipt_code": "510707",
        "affinityScore": "1"
    },
    {
        "career_code": "29902100",
        "cipt_code": "510707",
        "affinityScore": "1"
    },
    {
        "career_code": "31909400",
        "cipt_code": "510708",
        "affinityScore": "1"
    },
    {
        "career_code": "15123200",
        "cipt_code": "510709",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "510709",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "510710",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "510711",
        "affinityScore": "1"
    },
    {
        "career_code": "29909900",
        "cipt_code": "510711",
        "affinityScore": "1"
    },
    {
        "career_code": "31909200",
        "cipt_code": "510711",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510711",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "510711",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "510711",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "510712",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "510712",
        "affinityScore": "1"
    },
    {
        "career_code": "29207200",
        "cipt_code": "510713",
        "affinityScore": "1"
    },
    {
        "career_code": "29902100",
        "cipt_code": "510713",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510714",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "510714",
        "affinityScore": "1"
    },
    {
        "career_code": "13103100",
        "cipt_code": "510715",
        "affinityScore": "1"
    },
    {
        "career_code": "43601300",
        "cipt_code": "510716",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "510717",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510717",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510718",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "510719",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510719",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "510719",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510720",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "510720",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510721",
        "affinityScore": "1"
    },
    {
        "career_code": "29207200",
        "cipt_code": "510721",
        "affinityScore": "1"
    },
    {
        "career_code": "29902100",
        "cipt_code": "510721",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "510722",
        "affinityScore": "1"
    },
    {
        "career_code": "15121200",
        "cipt_code": "510723",
        "affinityScore": "1"
    },
    {
        "career_code": "29902100",
        "cipt_code": "510723",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510801",
        "affinityScore": "1"
    },
    {
        "career_code": "31909200",
        "cipt_code": "510801",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510802",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "510802",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510803",
        "affinityScore": "1"
    },
    {
        "career_code": "31201100",
        "cipt_code": "510803",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510805",
        "affinityScore": "1"
    },
    {
        "career_code": "29205200",
        "cipt_code": "510805",
        "affinityScore": "1"
    },
    {
        "career_code": "31202100",
        "cipt_code": "510806",
        "affinityScore": "1"
    },
    {
        "career_code": "31909200",
        "cipt_code": "510809",
        "affinityScore": "1"
    },
    {
        "career_code": "53301100",
        "cipt_code": "510810",
        "affinityScore": "1"
    },
    {
        "career_code": "29205500",
        "cipt_code": "510811",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510812",
        "affinityScore": "1"
    },
    {
        "career_code": "31909200",
        "cipt_code": "510813",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510814",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510814",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510815",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510816",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "510899",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510901",
        "affinityScore": "1"
    },
    {
        "career_code": "29203100",
        "cipt_code": "510901",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510902",
        "affinityScore": "1"
    },
    {
        "career_code": "29203100",
        "cipt_code": "510902",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510903",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510903",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510904",
        "affinityScore": "1"
    },
    {
        "career_code": "29204200",
        "cipt_code": "510904",
        "affinityScore": "1"
    },
    {
        "career_code": "29204300",
        "cipt_code": "510904",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510905",
        "affinityScore": "1"
    },
    {
        "career_code": "29203300",
        "cipt_code": "510905",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510906",
        "affinityScore": "1"
    },
    {
        "career_code": "29203100",
        "cipt_code": "510906",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510907",
        "affinityScore": "1"
    },
    {
        "career_code": "29112400",
        "cipt_code": "510907",
        "affinityScore": "1"
    },
    {
        "career_code": "29203400",
        "cipt_code": "510907",
        "affinityScore": "1"
    },
    {
        "career_code": "29203600",
        "cipt_code": "510907",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510907",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510908",
        "affinityScore": "1"
    },
    {
        "career_code": "29112600",
        "cipt_code": "510908",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510908",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510909",
        "affinityScore": "1"
    },
    {
        "career_code": "29205500",
        "cipt_code": "510909",
        "affinityScore": "1"
    },
    {
        "career_code": "29909300",
        "cipt_code": "510909",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510910",
        "affinityScore": "1"
    },
    {
        "career_code": "29203200",
        "cipt_code": "510910",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510911",
        "affinityScore": "1"
    },
    {
        "career_code": "29203400",
        "cipt_code": "510911",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510912",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "510912",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510913",
        "affinityScore": "1"
    },
    {
        "career_code": "29909100",
        "cipt_code": "510913",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510914",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510914",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510915",
        "affinityScore": "1"
    },
    {
        "career_code": "29203100",
        "cipt_code": "510915",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510915",
        "affinityScore": "1"
    },
    {
        "career_code": "19405100",
        "cipt_code": "510916",
        "affinityScore": "1"
    },
    {
        "career_code": "19501200",
        "cipt_code": "510916",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510916",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510916",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510917",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510917",
        "affinityScore": "1"
    },
    {
        "career_code": "29209200",
        "cipt_code": "510918",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510919",
        "affinityScore": "1"
    },
    {
        "career_code": "29203400",
        "cipt_code": "510919",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510920",
        "affinityScore": "1"
    },
    {
        "career_code": "29203500",
        "cipt_code": "510920",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510921",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510921",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510922",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510922",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510923",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510923",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "510999",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "510999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511001",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "511001",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511002",
        "affinityScore": "1"
    },
    {
        "career_code": "29201100",
        "cipt_code": "511002",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511003",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "511003",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511004",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "511004",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511005",
        "affinityScore": "1"
    },
    {
        "career_code": "29201100",
        "cipt_code": "511005",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511006",
        "affinityScore": "1"
    },
    {
        "career_code": "51908300",
        "cipt_code": "511006",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511007",
        "affinityScore": "1"
    },
    {
        "career_code": "29201100",
        "cipt_code": "511007",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511008",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "511008",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511009",
        "affinityScore": "1"
    },
    {
        "career_code": "31909700",
        "cipt_code": "511009",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511010",
        "affinityScore": "1"
    },
    {
        "career_code": "29201100",
        "cipt_code": "511010",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "511010",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511011",
        "affinityScore": "1"
    },
    {
        "career_code": "29209900",
        "cipt_code": "511011",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511012",
        "affinityScore": "1"
    },
    {
        "career_code": "29205500",
        "cipt_code": "511012",
        "affinityScore": "1"
    },
    {
        "career_code": "31909300",
        "cipt_code": "511012",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511099",
        "affinityScore": "1"
    },
    {
        "career_code": "29201100",
        "cipt_code": "511099",
        "affinityScore": "1"
    },
    {
        "career_code": "29201200",
        "cipt_code": "511099",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121200",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121800",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29124100",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29124200",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "511201",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121200",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121800",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29124100",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29124200",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "511202",
        "affinityScore": "1"
    },
    {
        "career_code": "29108100",
        "cipt_code": "511203",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "511401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104100",
        "cipt_code": "511401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "511401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "511402",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "511403",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "511404",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "511405",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511405",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "511499",
        "affinityScore": "1"
    },
    {
        "career_code": "21101100",
        "cipt_code": "511501",
        "affinityScore": "1"
    },
    {
        "career_code": "21101400",
        "cipt_code": "511501",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "511501",
        "affinityScore": "1"
    },
    {
        "career_code": "29205300",
        "cipt_code": "511502",
        "affinityScore": "1"
    },
    {
        "career_code": "31113300",
        "cipt_code": "511502",
        "affinityScore": "1"
    },
    {
        "career_code": "21101100",
        "cipt_code": "511503",
        "affinityScore": "1"
    },
    {
        "career_code": "21101400",
        "cipt_code": "511503",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "511503",
        "affinityScore": "1"
    },
    {
        "career_code": "21102300",
        "cipt_code": "511503",
        "affinityScore": "1"
    },
    {
        "career_code": "25111300",
        "cipt_code": "511503",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "511504",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "511504",
        "affinityScore": "1"
    },
    {
        "career_code": "21101300",
        "cipt_code": "511505",
        "affinityScore": "1"
    },
    {
        "career_code": "25106600",
        "cipt_code": "511505",
        "affinityScore": "1"
    },
    {
        "career_code": "21101300",
        "cipt_code": "511506",
        "affinityScore": "1"
    },
    {
        "career_code": "21101400",
        "cipt_code": "511506",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "511506",
        "affinityScore": "1"
    },
    {
        "career_code": "21201100",
        "cipt_code": "511506",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "511506",
        "affinityScore": "1"
    },
    {
        "career_code": "19303300",
        "cipt_code": "511507",
        "affinityScore": "1"
    },
    {
        "career_code": "21101400",
        "cipt_code": "511508",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "511509",
        "affinityScore": "1"
    },
    {
        "career_code": "21101300",
        "cipt_code": "511510",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "511510",
        "affinityScore": "1"
    },
    {
        "career_code": "21102100",
        "cipt_code": "511510",
        "affinityScore": "1"
    },
    {
        "career_code": "21101300",
        "cipt_code": "511511",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "511511",
        "affinityScore": "1"
    },
    {
        "career_code": "21102200",
        "cipt_code": "511512",
        "affinityScore": "1"
    },
    {
        "career_code": "21102900",
        "cipt_code": "511512",
        "affinityScore": "1"
    },
    {
        "career_code": "21101400",
        "cipt_code": "511513",
        "affinityScore": "1"
    },
    {
        "career_code": "29104100",
        "cipt_code": "511701",
        "affinityScore": "1"
    },
    {
        "career_code": "29208100",
        "cipt_code": "511801",
        "affinityScore": "1"
    },
    {
        "career_code": "29205700",
        "cipt_code": "511802",
        "affinityScore": "1"
    },
    {
        "career_code": "29205700",
        "cipt_code": "511803",
        "affinityScore": "1"
    },
    {
        "career_code": "29205700",
        "cipt_code": "511804",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512001",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512001",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "512001",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512002",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512002",
        "affinityScore": "1"
    },
    {
        "career_code": "19102100",
        "cipt_code": "512003",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "512003",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512003",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "512004",
        "affinityScore": "1"
    },
    {
        "career_code": "19203100",
        "cipt_code": "512004",
        "affinityScore": "1"
    },
    {
        "career_code": "25105200",
        "cipt_code": "512004",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512004",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "512005",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512005",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "512006",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "512006",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512006",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512007",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "512007",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "512007",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512007",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512008",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512008",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "512008",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "512009",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "512009",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512009",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "512010",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512010",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "512011",
        "affinityScore": "1"
    },
    {
        "career_code": "11202200",
        "cipt_code": "512011",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512011",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512011",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512099",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512201",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "512201",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "512201",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512201",
        "affinityScore": "1"
    },
    {
        "career_code": "19104100",
        "cipt_code": "512202",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "512202",
        "affinityScore": "1"
    },
    {
        "career_code": "19204100",
        "cipt_code": "512202",
        "affinityScore": "1"
    },
    {
        "career_code": "19501100",
        "cipt_code": "512202",
        "affinityScore": "1"
    },
    {
        "career_code": "19501200",
        "cipt_code": "512202",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512202",
        "affinityScore": "1"
    },
    {
        "career_code": "19201200",
        "cipt_code": "512205",
        "affinityScore": "1"
    },
    {
        "career_code": "25105400",
        "cipt_code": "512205",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512205",
        "affinityScore": "1"
    },
    {
        "career_code": "19501100",
        "cipt_code": "512206",
        "affinityScore": "1"
    },
    {
        "career_code": "19501200",
        "cipt_code": "512206",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512206",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "512207",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "512207",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512207",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512208",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "512208",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512208",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "512209",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "512209",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512209",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512210",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "512210",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512211",
        "affinityScore": "1"
    },
    {
        "career_code": "21109100",
        "cipt_code": "512212",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "512212",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512212",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512213",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "512213",
        "affinityScore": "1"
    },
    {
        "career_code": "19501100",
        "cipt_code": "512213",
        "affinityScore": "1"
    },
    {
        "career_code": "19501200",
        "cipt_code": "512213",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512213",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512214",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512214",
        "affinityScore": "1"
    },
    {
        "career_code": "29909200",
        "cipt_code": "512214",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "512299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512300",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512300",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512301",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512301",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512302",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512302",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512305",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512305",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512306",
        "affinityScore": "1"
    },
    {
        "career_code": "29112200",
        "cipt_code": "512306",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512307",
        "affinityScore": "1"
    },
    {
        "career_code": "29209100",
        "cipt_code": "512307",
        "affinityScore": "1"
    },
    {
        "career_code": "51908200",
        "cipt_code": "512307",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512308",
        "affinityScore": "1"
    },
    {
        "career_code": "29112300",
        "cipt_code": "512308",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512309",
        "affinityScore": "1"
    },
    {
        "career_code": "29112500",
        "cipt_code": "512309",
        "affinityScore": "1"
    },
    {
        "career_code": "21101500",
        "cipt_code": "512310",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512310",
        "affinityScore": "1"
    },
    {
        "career_code": "29112300",
        "cipt_code": "512311",
        "affinityScore": "1"
    },
    {
        "career_code": "29112800",
        "cipt_code": "512311",
        "affinityScore": "1"
    },
    {
        "career_code": "17219900",
        "cipt_code": "512312",
        "affinityScore": "1"
    },
    {
        "career_code": "21101500",
        "cipt_code": "512312",
        "affinityScore": "1"
    },
    {
        "career_code": "29209100",
        "cipt_code": "512312",
        "affinityScore": "1"
    },
    {
        "career_code": "51908200",
        "cipt_code": "512312",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512313",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512313",
        "affinityScore": "1"
    },
    {
        "career_code": "19109900",
        "cipt_code": "512314",
        "affinityScore": "1"
    },
    {
        "career_code": "21101500",
        "cipt_code": "512314",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512314",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512315",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512315",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512316",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512316",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512317",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512317",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "512399",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "512399",
        "affinityScore": "1"
    },
    {
        "career_code": "31113100",
        "cipt_code": "512601",
        "affinityScore": "1"
    },
    {
        "career_code": "31113300",
        "cipt_code": "512601",
        "affinityScore": "1"
    },
    {
        "career_code": "31112100",
        "cipt_code": "512602",
        "affinityScore": "1"
    },
    {
        "career_code": "31112200",
        "cipt_code": "512602",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "512603",
        "affinityScore": "1"
    },
    {
        "career_code": "31201200",
        "cipt_code": "512604",
        "affinityScore": "1"
    },
    {
        "career_code": "31202200",
        "cipt_code": "512604",
        "affinityScore": "1"
    },
    {
        "career_code": "31909900",
        "cipt_code": "512604",
        "affinityScore": "1"
    },
    {
        "career_code": "31202200",
        "cipt_code": "512605",
        "affinityScore": "1"
    },
    {
        "career_code": "27101300",
        "cipt_code": "512703",
        "affinityScore": "1"
    },
    {
        "career_code": "15122100",
        "cipt_code": "512706",
        "affinityScore": "1"
    },
    {
        "career_code": "15129900",
        "cipt_code": "512706",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "512706",
        "affinityScore": "1"
    },
    {
        "career_code": "29902100",
        "cipt_code": "512706",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "513101",
        "affinityScore": "1"
    },
    {
        "career_code": "29205100",
        "cipt_code": "513101",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "513102",
        "affinityScore": "1"
    },
    {
        "career_code": "29205100",
        "cipt_code": "513103",
        "affinityScore": "1"
    },
    {
        "career_code": "29205100",
        "cipt_code": "513104",
        "affinityScore": "1"
    },
    {
        "career_code": "29103100",
        "cipt_code": "513199",
        "affinityScore": "1"
    },
    {
        "career_code": "21202100",
        "cipt_code": "513201",
        "affinityScore": "1"
    },
    {
        "career_code": "25112600",
        "cipt_code": "513201",
        "affinityScore": "1"
    },
    {
        "career_code": "29909900",
        "cipt_code": "513201",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "513202",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "513202",
        "affinityScore": "1"
    },
    {
        "career_code": "25108100",
        "cipt_code": "513202",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "513203",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513203",
        "affinityScore": "1"
    },
    {
        "career_code": "19304100",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "19309100",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "19309200",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "19309900",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "25106900",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "513204",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "513205",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "513205",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "513206",
        "affinityScore": "1"
    },
    {
        "career_code": "21109400",
        "cipt_code": "513206",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "513299",
        "affinityScore": "1"
    },
    {
        "career_code": "25119900",
        "cipt_code": "513299",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513300",
        "affinityScore": "1"
    },
    {
        "career_code": "29129100",
        "cipt_code": "513301",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513301",
        "affinityScore": "1"
    },
    {
        "career_code": "29909900",
        "cipt_code": "513302",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513303",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513304",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513305",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513306",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513399",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513401",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "513501",
        "affinityScore": "1"
    },
    {
        "career_code": "31901100",
        "cipt_code": "513501",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "513502",
        "affinityScore": "1"
    },
    {
        "career_code": "31901100",
        "cipt_code": "513502",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "513503",
        "affinityScore": "1"
    },
    {
        "career_code": "31901100",
        "cipt_code": "513503",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "513599",
        "affinityScore": "1"
    },
    {
        "career_code": "31901100",
        "cipt_code": "513599",
        "affinityScore": "1"
    },
    {
        "career_code": "29112900",
        "cipt_code": "513601",
        "affinityScore": "1"
    },
    {
        "career_code": "39903100",
        "cipt_code": "513602",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "513603",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513701",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513702",
        "affinityScore": "1"
    },
    {
        "career_code": "29909900",
        "cipt_code": "513702",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513703",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513704",
        "affinityScore": "1"
    },
    {
        "career_code": "29129900",
        "cipt_code": "513799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513801",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513801",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "513802",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513802",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513802",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513803",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513803",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513803",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513804",
        "affinityScore": "1"
    },
    {
        "career_code": "29115100",
        "cipt_code": "513804",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513805",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513805",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513805",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513806",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513806",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513806",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513807",
        "affinityScore": "1"
    },
    {
        "career_code": "29116100",
        "cipt_code": "513807",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513808",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513808",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513808",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513809",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513809",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513809",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513810",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513810",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513810",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513811",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513811",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513811",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513812",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513812",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513812",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513813",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513813",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513813",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513814",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513814",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513814",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513815",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513815",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513815",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513816",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513816",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513816",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "513818",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513818",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513818",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513818",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513819",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513819",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513819",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "513820",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513820",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513820",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513820",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513821",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513821",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513821",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513822",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513822",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513822",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513824",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513824",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513824",
        "affinityScore": "1"
    },
    {
        "career_code": "25107200",
        "cipt_code": "513899",
        "affinityScore": "1"
    },
    {
        "career_code": "29114100",
        "cipt_code": "513899",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "513899",
        "affinityScore": "1"
    },
    {
        "career_code": "29206100",
        "cipt_code": "513901",
        "affinityScore": "1"
    },
    {
        "career_code": "31113100",
        "cipt_code": "513902",
        "affinityScore": "1"
    },
    {
        "career_code": "29206100",
        "cipt_code": "513999",
        "affinityScore": "1"
    },
    {
        "career_code": "31113100",
        "cipt_code": "513999",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11202200",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "13108200",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520101",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11202200",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11311100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13105100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13107100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13108100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13108200",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13114100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "13119900",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520201",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "520202",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "520202",
        "affinityScore": "1"
    },
    {
        "career_code": "11306100",
        "cipt_code": "520202",
        "affinityScore": "1"
    },
    {
        "career_code": "13101100",
        "cipt_code": "520202",
        "affinityScore": "1"
    },
    {
        "career_code": "13102300",
        "cipt_code": "520202",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520202",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "520203",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "520203",
        "affinityScore": "1"
    },
    {
        "career_code": "13108100",
        "cipt_code": "520203",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520203",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "520204",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "520204",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "13108100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "49101100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "51101100",
        "cipt_code": "520205",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11903900",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11915100",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "13209900",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520206",
        "affinityScore": "1"
    },
    {
        "career_code": "11301200",
        "cipt_code": "520207",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "520207",
        "affinityScore": "1"
    },
    {
        "career_code": "13119900",
        "cipt_code": "520208",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "520208",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "520208",
        "affinityScore": "1"
    },
    {
        "career_code": "11307100",
        "cipt_code": "520209",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "520210",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "520210",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520210",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520210",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520211",
        "affinityScore": "1"
    },
    {
        "career_code": "13108200",
        "cipt_code": "520211",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520211",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520212",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "520212",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520212",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "520212",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "520213",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "520213",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "520213",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520213",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "520213",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520213",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "520214",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "520214",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "520214",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520214",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "520214",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520215",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520215",
        "affinityScore": "1"
    },
    {
        "career_code": "13205300",
        "cipt_code": "520215",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520215",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "520215",
        "affinityScore": "1"
    },
    {
        "career_code": "11305100",
        "cipt_code": "520216",
        "affinityScore": "1"
    },
    {
        "career_code": "11904100",
        "cipt_code": "520216",
        "affinityScore": "1"
    },
    {
        "career_code": "11911100",
        "cipt_code": "520216",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "520216",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520216",
        "affinityScore": "1"
    },
    {
        "career_code": "13108200",
        "cipt_code": "520216",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13203100",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13204100",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13206100",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13208100",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13208200",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520301",
        "affinityScore": "1"
    },
    {
        "career_code": "13208200",
        "cipt_code": "520302",
        "affinityScore": "1"
    },
    {
        "career_code": "43303100",
        "cipt_code": "520302",
        "affinityScore": "1"
    },
    {
        "career_code": "43305100",
        "cipt_code": "520302",
        "affinityScore": "1"
    },
    {
        "career_code": "43401100",
        "cipt_code": "520302",
        "affinityScore": "1"
    },
    {
        "career_code": "43911100",
        "cipt_code": "520302",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "520303",
        "affinityScore": "1"
    },
    {
        "career_code": "13206100",
        "cipt_code": "520303",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520303",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "13203100",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520304",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520305",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "520305",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "520305",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520305",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520305",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520305",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "520401",
        "affinityScore": "1"
    },
    {
        "career_code": "43416100",
        "cipt_code": "520401",
        "affinityScore": "1"
    },
    {
        "career_code": "43601100",
        "cipt_code": "520401",
        "affinityScore": "1"
    },
    {
        "career_code": "43601400",
        "cipt_code": "520401",
        "affinityScore": "1"
    },
    {
        "career_code": "43101100",
        "cipt_code": "520402",
        "affinityScore": "1"
    },
    {
        "career_code": "43601100",
        "cipt_code": "520402",
        "affinityScore": "1"
    },
    {
        "career_code": "43601400",
        "cipt_code": "520402",
        "affinityScore": "1"
    },
    {
        "career_code": "43405100",
        "cipt_code": "520406",
        "affinityScore": "1"
    },
    {
        "career_code": "43415100",
        "cipt_code": "520406",
        "affinityScore": "1"
    },
    {
        "career_code": "43417100",
        "cipt_code": "520406",
        "affinityScore": "1"
    },
    {
        "career_code": "43416100",
        "cipt_code": "520407",
        "affinityScore": "1"
    },
    {
        "career_code": "43902100",
        "cipt_code": "520407",
        "affinityScore": "1"
    },
    {
        "career_code": "43306100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43402100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43407100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43415100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43501100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43902200",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43904100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43906100",
        "cipt_code": "520408",
        "affinityScore": "1"
    },
    {
        "career_code": "43506100",
        "cipt_code": "520409",
        "affinityScore": "1"
    },
    {
        "career_code": "43501100",
        "cipt_code": "520410",
        "affinityScore": "1"
    },
    {
        "career_code": "43503200",
        "cipt_code": "520410",
        "affinityScore": "1"
    },
    {
        "career_code": "43405100",
        "cipt_code": "520411",
        "affinityScore": "1"
    },
    {
        "career_code": "43415100",
        "cipt_code": "520411",
        "affinityScore": "1"
    },
    {
        "career_code": "13119900",
        "cipt_code": "520499",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "43908100",
        "cipt_code": "520501",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "520502",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "520502",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "520502",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "520502",
        "affinityScore": "1"
    },
    {
        "career_code": "11203200",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "25112200",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "27303100",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "27304100",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "27304200",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "27304300",
        "cipt_code": "520599",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "520601",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520601",
        "affinityScore": "1"
    },
    {
        "career_code": "19301100",
        "cipt_code": "520601",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "520601",
        "affinityScore": "1"
    },
    {
        "career_code": "25106300",
        "cipt_code": "520601",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "520701",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520701",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520701",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520701",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520702",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520702",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "520703",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520703",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "520704",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520704",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520704",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13114100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13203100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13204100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13205200",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13207200",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13209900",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520801",
        "affinityScore": "1"
    },
    {
        "career_code": "13207100",
        "cipt_code": "520803",
        "affinityScore": "1"
    },
    {
        "career_code": "43301100",
        "cipt_code": "520803",
        "affinityScore": "1"
    },
    {
        "career_code": "43307100",
        "cipt_code": "520803",
        "affinityScore": "1"
    },
    {
        "career_code": "43404100",
        "cipt_code": "520803",
        "affinityScore": "1"
    },
    {
        "career_code": "43413100",
        "cipt_code": "520803",
        "affinityScore": "1"
    },
    {
        "career_code": "43414100",
        "cipt_code": "520803",
        "affinityScore": "1"
    },
    {
        "career_code": "13205200",
        "cipt_code": "520804",
        "affinityScore": "1"
    },
    {
        "career_code": "13207100",
        "cipt_code": "520804",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520804",
        "affinityScore": "1"
    },
    {
        "career_code": "41303100",
        "cipt_code": "520804",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520806",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520806",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520806",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520806",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520807",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520807",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520807",
        "affinityScore": "1"
    },
    {
        "career_code": "41303100",
        "cipt_code": "520807",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520808",
        "affinityScore": "1"
    },
    {
        "career_code": "13203100",
        "cipt_code": "520808",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520808",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520808",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520808",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520809",
        "affinityScore": "1"
    },
    {
        "career_code": "13204100",
        "cipt_code": "520809",
        "affinityScore": "1"
    },
    {
        "career_code": "13207100",
        "cipt_code": "520809",
        "affinityScore": "1"
    },
    {
        "career_code": "13207200",
        "cipt_code": "520809",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "13204100",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "13205100",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "13205300",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520810",
        "affinityScore": "1"
    },
    {
        "career_code": "11303100",
        "cipt_code": "520899",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "520901",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "520901",
        "affinityScore": "1"
    },
    {
        "career_code": "11908100",
        "cipt_code": "520901",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "520901",
        "affinityScore": "1"
    },
    {
        "career_code": "11917900",
        "cipt_code": "520903",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520903",
        "affinityScore": "1"
    },
    {
        "career_code": "39701200",
        "cipt_code": "520903",
        "affinityScore": "1"
    },
    {
        "career_code": "11301300",
        "cipt_code": "520904",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "520904",
        "affinityScore": "1"
    },
    {
        "career_code": "11908100",
        "cipt_code": "520904",
        "affinityScore": "1"
    },
    {
        "career_code": "13119900",
        "cipt_code": "520904",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "520905",
        "affinityScore": "1"
    },
    {
        "career_code": "11908100",
        "cipt_code": "520905",
        "affinityScore": "1"
    },
    {
        "career_code": "11907200",
        "cipt_code": "520906",
        "affinityScore": "1"
    },
    {
        "career_code": "11908100",
        "cipt_code": "520906",
        "affinityScore": "1"
    },
    {
        "career_code": "13112100",
        "cipt_code": "520907",
        "affinityScore": "1"
    },
    {
        "career_code": "11907100",
        "cipt_code": "520908",
        "affinityScore": "1"
    },
    {
        "career_code": "39101300",
        "cipt_code": "520908",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "520909",
        "affinityScore": "1"
    },
    {
        "career_code": "11908100",
        "cipt_code": "520909",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "520909",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "520910",
        "affinityScore": "1"
    },
    {
        "career_code": "11905100",
        "cipt_code": "520999",
        "affinityScore": "1"
    },
    {
        "career_code": "11908100",
        "cipt_code": "520999",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "520999",
        "affinityScore": "1"
    },
    {
        "career_code": "11311100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "13107100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "13107500",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "13114100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "43416100",
        "cipt_code": "521001",
        "affinityScore": "1"
    },
    {
        "career_code": "11311100",
        "cipt_code": "521002",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "521002",
        "affinityScore": "1"
    },
    {
        "career_code": "13104100",
        "cipt_code": "521002",
        "affinityScore": "1"
    },
    {
        "career_code": "13107500",
        "cipt_code": "521002",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521002",
        "affinityScore": "1"
    },
    {
        "career_code": "25111200",
        "cipt_code": "521002",
        "affinityScore": "1"
    },
    {
        "career_code": "11311100",
        "cipt_code": "521003",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "521003",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "521003",
        "affinityScore": "1"
    },
    {
        "career_code": "13107100",
        "cipt_code": "521003",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521003",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "521004",
        "affinityScore": "1"
    },
    {
        "career_code": "13107500",
        "cipt_code": "521004",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521004",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "521005",
        "affinityScore": "1"
    },
    {
        "career_code": "11312100",
        "cipt_code": "521006",
        "affinityScore": "1"
    },
    {
        "career_code": "11313100",
        "cipt_code": "521006",
        "affinityScore": "1"
    },
    {
        "career_code": "13107100",
        "cipt_code": "521006",
        "affinityScore": "1"
    },
    {
        "career_code": "13115100",
        "cipt_code": "521006",
        "affinityScore": "1"
    },
    {
        "career_code": "21101200",
        "cipt_code": "521006",
        "affinityScore": "1"
    },
    {
        "career_code": "21101900",
        "cipt_code": "521006",
        "affinityScore": "1"
    },
    {
        "career_code": "13107100",
        "cipt_code": "521099",
        "affinityScore": "1"
    },
    {
        "career_code": "43416100",
        "cipt_code": "521099",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "521101",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "521101",
        "affinityScore": "1"
    },
    {
        "career_code": "13119900",
        "cipt_code": "521101",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521101",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "521201",
        "affinityScore": "1"
    },
    {
        "career_code": "15124300",
        "cipt_code": "521201",
        "affinityScore": "1"
    },
    {
        "career_code": "15125100",
        "cipt_code": "521201",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "521201",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "521206",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "521206",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "521207",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "521207",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "521299",
        "affinityScore": "1"
    },
    {
        "career_code": "25102100",
        "cipt_code": "521299",
        "affinityScore": "1"
    },
    {
        "career_code": "11101100",
        "cipt_code": "521301",
        "affinityScore": "1"
    },
    {
        "career_code": "11102100",
        "cipt_code": "521301",
        "affinityScore": "1"
    },
    {
        "career_code": "13111100",
        "cipt_code": "521301",
        "affinityScore": "1"
    },
    {
        "career_code": "15203100",
        "cipt_code": "521301",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "521301",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521301",
        "affinityScore": "1"
    },
    {
        "career_code": "15204100",
        "cipt_code": "521302",
        "affinityScore": "1"
    },
    {
        "career_code": "15205100",
        "cipt_code": "521302",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "521302",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521302",
        "affinityScore": "1"
    },
    {
        "career_code": "25102200",
        "cipt_code": "521302",
        "affinityScore": "1"
    },
    {
        "career_code": "13205300",
        "cipt_code": "521304",
        "affinityScore": "1"
    },
    {
        "career_code": "13205400",
        "cipt_code": "521304",
        "affinityScore": "1"
    },
    {
        "career_code": "15201100",
        "cipt_code": "521304",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521304",
        "affinityScore": "1"
    },
    {
        "career_code": "11201100",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "11202200",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "11203300",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "13113100",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521401",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "521402",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521402",
        "affinityScore": "1"
    },
    {
        "career_code": "19302200",
        "cipt_code": "521402",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521402",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "521403",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521403",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521403",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "521404",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521404",
        "affinityScore": "1"
    },
    {
        "career_code": "15125500",
        "cipt_code": "521404",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521404",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "521499",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521499",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521499",
        "affinityScore": "1"
    },
    {
        "career_code": "11914100",
        "cipt_code": "521501",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "521501",
        "affinityScore": "1"
    },
    {
        "career_code": "13202300",
        "cipt_code": "521501",
        "affinityScore": "1"
    },
    {
        "career_code": "41902100",
        "cipt_code": "521501",
        "affinityScore": "1"
    },
    {
        "career_code": "41902200",
        "cipt_code": "521501",
        "affinityScore": "1"
    },
    {
        "career_code": "13201100",
        "cipt_code": "521601",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "521601",
        "affinityScore": "1"
    },
    {
        "career_code": "13206100",
        "cipt_code": "521601",
        "affinityScore": "1"
    },
    {
        "career_code": "13208100",
        "cipt_code": "521601",
        "affinityScore": "1"
    },
    {
        "career_code": "13208200",
        "cipt_code": "521601",
        "affinityScore": "1"
    },
    {
        "career_code": "11311100",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "13103100",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "13103200",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "13114100",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "13202200",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "13205300",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "41302100",
        "cipt_code": "521701",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "521801",
        "affinityScore": "1"
    },
    {
        "career_code": "13102300",
        "cipt_code": "521801",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "521801",
        "affinityScore": "1"
    },
    {
        "career_code": "41401200",
        "cipt_code": "521801",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "521802",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "521803",
        "affinityScore": "1"
    },
    {
        "career_code": "41309100",
        "cipt_code": "521803",
        "affinityScore": "1"
    },
    {
        "career_code": "41901100",
        "cipt_code": "521803",
        "affinityScore": "1"
    },
    {
        "career_code": "41909900",
        "cipt_code": "521803",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41101200",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41202200",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41301100",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41304100",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41309100",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41401100",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "41909900",
        "cipt_code": "521804",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "521899",
        "affinityScore": "1"
    },
    {
        "career_code": "13102300",
        "cipt_code": "521899",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "521899",
        "affinityScore": "1"
    },
    {
        "career_code": "41101200",
        "cipt_code": "521899",
        "affinityScore": "1"
    },
    {
        "career_code": "41401200",
        "cipt_code": "521899",
        "affinityScore": "1"
    },
    {
        "career_code": "41909900",
        "cipt_code": "521901",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "521902",
        "affinityScore": "1"
    },
    {
        "career_code": "41401200",
        "cipt_code": "521902",
        "affinityScore": "1"
    },
    {
        "career_code": "27102600",
        "cipt_code": "521903",
        "affinityScore": "1"
    },
    {
        "career_code": "41901200",
        "cipt_code": "521903",
        "affinityScore": "1"
    },
    {
        "career_code": "13102200",
        "cipt_code": "521904",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521904",
        "affinityScore": "1"
    },
    {
        "career_code": "41401200",
        "cipt_code": "521904",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521905",
        "affinityScore": "1"
    },
    {
        "career_code": "41304100",
        "cipt_code": "521905",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521906",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521907",
        "affinityScore": "1"
    },
    {
        "career_code": "41202200",
        "cipt_code": "521907",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521908",
        "affinityScore": "1"
    },
    {
        "career_code": "41303100",
        "cipt_code": "521908",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521909",
        "affinityScore": "1"
    },
    {
        "career_code": "41101100",
        "cipt_code": "521909",
        "affinityScore": "1"
    },
    {
        "career_code": "41101200",
        "cipt_code": "521909",
        "affinityScore": "1"
    },
    {
        "career_code": "41401200",
        "cipt_code": "521909",
        "affinityScore": "1"
    },
    {
        "career_code": "41909900",
        "cipt_code": "521909",
        "affinityScore": "1"
    },
    {
        "career_code": "11202100",
        "cipt_code": "521910",
        "affinityScore": "1"
    },
    {
        "career_code": "13116100",
        "cipt_code": "521910",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "522001",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "522002",
        "affinityScore": "1"
    },
    {
        "career_code": "13108200",
        "cipt_code": "522002",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "522002",
        "affinityScore": "1"
    },
    {
        "career_code": "11902100",
        "cipt_code": "522099",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "522099",
        "affinityScore": "1"
    },
    {
        "career_code": "11302100",
        "cipt_code": "522101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "522101",
        "affinityScore": "1"
    },
    {
        "career_code": "25101100",
        "cipt_code": "522101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540101",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540101",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540101",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "540101",
        "affinityScore": "1"
    },
    {
        "career_code": "39701100",
        "cipt_code": "540101",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540102",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540102",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540102",
        "affinityScore": "1"
    },
    {
        "career_code": "25203100",
        "cipt_code": "540102",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540103",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540103",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540103",
        "affinityScore": "1"
    },
    {
        "career_code": "11912100",
        "cipt_code": "540104",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540104",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540104",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540104",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540105",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540105",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540105",
        "affinityScore": "1"
    },
    {
        "career_code": "25401100",
        "cipt_code": "540105",
        "affinityScore": "1"
    },
    {
        "career_code": "25401200",
        "cipt_code": "540105",
        "affinityScore": "1"
    },
    {
        "career_code": "25401300",
        "cipt_code": "540105",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540106",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540106",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540106",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540107",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540107",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540107",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540108",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540108",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540108",
        "affinityScore": "1"
    },
    {
        "career_code": "11919900",
        "cipt_code": "540199",
        "affinityScore": "1"
    },
    {
        "career_code": "19309300",
        "cipt_code": "540199",
        "affinityScore": "1"
    },
    {
        "career_code": "25112500",
        "cipt_code": "540199",
        "affinityScore": "1"
    },
    {
        "career_code": "29102200",
        "cipt_code": "600101",
        "affinityScore": "1"
    },
    {
        "career_code": "29102100",
        "cipt_code": "600102",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600102",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600103",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600104",
        "affinityScore": "1"
    },
    {
        "career_code": "29102300",
        "cipt_code": "600105",
        "affinityScore": "1"
    },
    {
        "career_code": "29102100",
        "cipt_code": "600106",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600106",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600107",
        "affinityScore": "1"
    },
    {
        "career_code": "29102400",
        "cipt_code": "600108",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600109",
        "affinityScore": "1"
    },
    {
        "career_code": "29102400",
        "cipt_code": "600110",
        "affinityScore": "1"
    },
    {
        "career_code": "29102900",
        "cipt_code": "600199",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600301",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600302",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600303",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600304",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600305",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600306",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600307",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600308",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600309",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600310",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600311",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600312",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600313",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600314",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600315",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600316",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600317",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600318",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600319",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600320",
        "affinityScore": "1"
    },
    {
        "career_code": "29113100",
        "cipt_code": "600399",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600701",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600702",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600703",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600704",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600705",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600706",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600707",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600708",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600709",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600710",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600711",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600712",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600713",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600714",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600715",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600716",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600717",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600718",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600719",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600720",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600721",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600722",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600723",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600724",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600725",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600726",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600727",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600728",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600729",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600730",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600731",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600732",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600733",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600734",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600735",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600736",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600737",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600738",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600739",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600740",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600741",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600742",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600743",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600744",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600745",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600746",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600747",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600748",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600749",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600750",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600751",
        "affinityScore": "1"
    },
    {
        "career_code": "29117100",
        "cipt_code": "600799",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600801",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600802",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600803",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600804",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600805",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600806",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600807",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600808",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600809",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600810",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600811",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600812",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600813",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600814",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600815",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600816",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600817",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600818",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600819",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600820",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600821",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600822",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600823",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600824",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600825",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600826",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600827",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600828",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600829",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600830",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600831",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600832",
        "affinityScore": "1"
    },
    {
        "career_code": "29105100",
        "cipt_code": "600899",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600901",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600902",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600903",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600904",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600905",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600906",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600907",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600908",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600909",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600910",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600911",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600912",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600913",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600914",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600915",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600916",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600917",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600918",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600919",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600920",
        "affinityScore": "1"
    },
    {
        "career_code": "29107100",
        "cipt_code": "600999",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610101",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610101",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610101",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "610101",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610102",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610102",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "610102",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610103",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610103",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "610103",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610103",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610104",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610104",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610104",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610104",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610105",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610105",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610105",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610105",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610106",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610106",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610106",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610106",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610107",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610107",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610107",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "610107",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610108",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610108",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "610108",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610108",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610109",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610109",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "610109",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610109",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610110",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610110",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610110",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610110",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610111",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610111",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610111",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610111",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610112",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610112",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610112",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610112",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610113",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610113",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610113",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610114",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610114",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610114",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "610114",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610115",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610115",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610115",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "610115",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610116",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610116",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610116",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610116",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610117",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610117",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610117",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "610117",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610118",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610118",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610118",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610119",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610119",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "610119",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "610119",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610120",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610120",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610120",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "610120",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610121",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610121",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "610121",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610121",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610122",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610122",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "610122",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610122",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610123",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610123",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "610123",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "610123",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610124",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610124",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "610124",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "610124",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610125",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610125",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610125",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610199",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610199",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610199",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "610199",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610202",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610202",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610202",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610203",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610203",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610203",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610204",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610205",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610205",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610205",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610206",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610206",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610206",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "610207",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610207",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610208",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610208",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "610208",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610208",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610209",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610209",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610209",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610210",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610210",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610210",
        "affinityScore": "1"
    },
    {
        "career_code": "11903300",
        "cipt_code": "610211",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610211",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610212",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610212",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610212",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610213",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610213",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610213",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610214",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610214",
        "affinityScore": "1"
    },
    {
        "career_code": "29124200",
        "cipt_code": "610214",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610215",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610215",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610215",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610216",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610216",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610216",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610217",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610217",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610217",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610218",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610218",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610218",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610299",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610299",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "610299",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610301",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610301",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610301",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610399",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610401",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "610401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610499",
        "affinityScore": "1"
    },
    {
        "career_code": "29121100",
        "cipt_code": "610499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610501",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "610501",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610502",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610502",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "610502",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "610502",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610503",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610503",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "610503",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610599",
        "affinityScore": "1"
    },
    {
        "career_code": "29121300",
        "cipt_code": "610599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610601",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610601",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610602",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610602",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610602",
        "affinityScore": "1"
    },
    {
        "career_code": "11916100",
        "cipt_code": "610603",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610603",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610603",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610603",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610699",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610699",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "610699",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610701",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610701",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610799",
        "affinityScore": "1"
    },
    {
        "career_code": "29121500",
        "cipt_code": "610799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610801",
        "affinityScore": "1"
    },
    {
        "career_code": "29121600",
        "cipt_code": "610801",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610804",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610804",
        "affinityScore": "1"
    },
    {
        "career_code": "29121200",
        "cipt_code": "610804",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610805",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610805",
        "affinityScore": "1"
    },
    {
        "career_code": "29121200",
        "cipt_code": "610805",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610806",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610806",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610806",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610807",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610807",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610807",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610808",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610808",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610808",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610809",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610809",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610809",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610810",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610810",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610810",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610811",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610811",
        "affinityScore": "1"
    },
    {
        "career_code": "29121200",
        "cipt_code": "610811",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610812",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610812",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610812",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610813",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610813",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610813",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610814",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610814",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610814",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610816",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610816",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610816",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610818",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610818",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610818",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610899",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610899",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610899",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610901",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610901",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610901",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610902",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610902",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610902",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610903",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610903",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610903",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610904",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610904",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610904",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "610999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "610999",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "610999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611001",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "611001",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611099",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611099",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "611099",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611101",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611101",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611102",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611102",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611103",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611103",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611103",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611104",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611104",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611104",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611105",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611105",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611105",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611106",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611106",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611106",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611107",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611107",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611107",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611199",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611199",
        "affinityScore": "1"
    },
    {
        "career_code": "29121700",
        "cipt_code": "611199",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611201",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "611201",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611299",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "611299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611301",
        "affinityScore": "1"
    },
    {
        "career_code": "29121800",
        "cipt_code": "611301",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611302",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611302",
        "affinityScore": "1"
    },
    {
        "career_code": "29121800",
        "cipt_code": "611302",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611303",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611303",
        "affinityScore": "1"
    },
    {
        "career_code": "29121800",
        "cipt_code": "611303",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611304",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611304",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611304",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611399",
        "affinityScore": "1"
    },
    {
        "career_code": "29121800",
        "cipt_code": "611399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611401",
        "affinityScore": "1"
    },
    {
        "career_code": "29124100",
        "cipt_code": "611401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611499",
        "affinityScore": "1"
    },
    {
        "career_code": "29124100",
        "cipt_code": "611499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611501",
        "affinityScore": "1"
    },
    {
        "career_code": "29124200",
        "cipt_code": "611501",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "611501",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611502",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611502",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611502",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611503",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611503",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611503",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611504",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611504",
        "affinityScore": "1"
    },
    {
        "career_code": "29124200",
        "cipt_code": "611504",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "611504",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611505",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611505",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "611505",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611599",
        "affinityScore": "1"
    },
    {
        "career_code": "29124200",
        "cipt_code": "611599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611601",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611601",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611699",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611699",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611699",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611701",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611701",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "611701",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611702",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611702",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611702",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "611702",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611703",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611703",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611703",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "611703",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611799",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611799",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "611799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611801",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611801",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611802",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611802",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611803",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611803",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611804",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611804",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611804",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611804",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611805",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611805",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611805",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611806",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611806",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611806",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611807",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611807",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611807",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611808",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611808",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611808",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611809",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611809",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611809",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611810",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611810",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611810",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611811",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611811",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611811",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611812",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611812",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611812",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611813",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611813",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611813",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611814",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611814",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611814",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611815",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611815",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611815",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611899",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611899",
        "affinityScore": "1"
    },
    {
        "career_code": "29122200",
        "cipt_code": "611899",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611901",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611901",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611902",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611902",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611902",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "611902",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611903",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611903",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611903",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611904",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611904",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611904",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611905",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611905",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611905",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611906",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611906",
        "affinityScore": "1"
    },
    {
        "career_code": "29121200",
        "cipt_code": "611906",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611906",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611907",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611907",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "611907",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611907",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611908",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611908",
        "affinityScore": "1"
    },
    {
        "career_code": "29121400",
        "cipt_code": "611908",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611908",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611909",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611909",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611909",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611910",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611910",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611910",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611911",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611911",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611911",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611912",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611912",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611912",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611913",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611913",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611913",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611914",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611914",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611914",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611915",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611915",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611915",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611917",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611917",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611917",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "611999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "611999",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "611999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612001",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612001",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612002",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612002",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612002",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612003",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612003",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "612003",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612099",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612099",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612099",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612101",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612101",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612101",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612102",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612102",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612102",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612103",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612103",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612103",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612103",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612199",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612199",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612199",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612199",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612201",
        "affinityScore": "1"
    },
    {
        "career_code": "29108100",
        "cipt_code": "612201",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612299",
        "affinityScore": "1"
    },
    {
        "career_code": "29108100",
        "cipt_code": "612299",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612301",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612301",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612302",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612302",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612303",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612303",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612399",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612399",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612401",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612401",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612402",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612402",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612402",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612403",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612403",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612403",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612404",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612404",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612404",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612405",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612405",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612405",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612406",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612406",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612406",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612499",
        "affinityScore": "1"
    },
    {
        "career_code": "29122300",
        "cipt_code": "612499",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612501",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612501",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612501",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612599",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612599",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "612599",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612601",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612601",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612602",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612602",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612603",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612603",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612603",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612604",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612604",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612605",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612605",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612606",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612606",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612606",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612607",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612607",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612607",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612608",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612608",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612608",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612609",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612609",
        "affinityScore": "1"
    },
    {
        "career_code": "29122100",
        "cipt_code": "612609",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612609",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612610",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612610",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612611",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612611",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612612",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612612",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612612",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612699",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612699",
        "affinityScore": "1"
    },
    {
        "career_code": "29122400",
        "cipt_code": "612699",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612701",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612701",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612702",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612702",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612703",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612703",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612703",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612704",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612704",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612704",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612704",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612705",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612705",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612705",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612706",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612706",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612706",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612707",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612707",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612707",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612708",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612708",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612708",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612799",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612799",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612801",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612801",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612802",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612802",
        "affinityScore": "1"
    },
    {
        "career_code": "29124300",
        "cipt_code": "612802",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "612899",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "612899",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "612899",
        "affinityScore": "1"
    },
    {
        "career_code": "19104200",
        "cipt_code": "619999",
        "affinityScore": "1"
    },
    {
        "career_code": "25107100",
        "cipt_code": "619999",
        "affinityScore": "1"
    },
    {
        "career_code": "29122900",
        "cipt_code": "619999",
        "affinityScore": "1"
    },
    {
        "career_code": "29124900",
        "cipt_code": "619999",
        "affinityScore": "1"
    }
];
